import React, { useEffect,useState,useRef } from 'react' 
import HeaderofAdash from '../../subComponent/HeaderofAdash'
import SidebarOfAdash from '../../subComponent/SidebarOfAdash'
import { adminHeaderApi } from '../../../../utils/AdminDashApi/HeaderApi'
import { BiBell } from 'react-icons/bi'
import {Row,Col,Modal,Tab,Nav} from 'react-bootstrap'
import '../../../../sassFiles/sassPages/admindashboard/bill/billlallstyle.scss'
import '../../../../sassFiles/sassPages/admindashboard/studentEntryMainPage.scss'
import { billCollectionApi, prevCollectionhistoryApi, searchEmptableApi, searchtableApi } from '../../../../utils/AdminDashApi/Bill/BillApi'
import { optionsCampus, optionsCity, optionsCountry, optionsDistrict, optionsDivision, optionsShift, optionsStatusAI, optionsSubject, optionsThana, optionsapplicationstatus, optionsbilltype, optionsbloodgroup, optionscompany, optionsdesignation, optionsgender, optionsmaritalstatus, optionsmarkallow, optionsnationality, optionspersontype, optionsposition, optionsqualification, optionsreligion, optionssection, optionssession } from '../../../Helper'
import Dropdown2 from '../../../subComponents/CustomSubComponents/Dropdown2'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { HighlightRowText } from '../../../../pages/adminDashboard/Bill/subComponents/HighlightRowText'
import { statusTableApi } from '../../../../utils/DashboardApi/AdminDashboard/StatusTableApi'
import { paymenthistorystuApi } from '../../../../utils/DashboardApi/AdminDashboard/paymenthistorystuApi'
import { tr } from 'date-fns/locale'
import Purplebutton from '../subComponent/Purplebutton'
import { employeeEntryexperienceApi, employeeEntryqualificationApi } from '../../../../utils/AdminDashApi/Employee/EmployeeEntryMainApi'
import { validationComp, validationDrp } from '../../../subComponents/CustomSubComponents/ValidationComp'
import { fetchBoardDrpDown, fetchCampusDropdown, fetchCompanyDrpDown, fetchCompanyTypeDrpDown, fetchCountryDropdown, fetchDepartmentTypeDrpDown, fetchDesignationTypeDrpDown, fetchEmpGenderDropDownn, fetchGenderDropdown, fetchInstituteDrpDown, fetchMaritalStatusDrpDown, fetchPersonTypeDrpDown, fetchPositionDrpDown, fetchQulificationDrpDown, fetchSubjectDrpDown, fetchUnitTypeDrpDown, fetchbloodgroupDropdown, fetchdistrictDropdown, fetchdivisionDropdown, fetchnationalityDropdown, fetchreligionDropdown, fetchthanaDropdown } from '../../../../utils/Api_Calls/api_calls_all'

const EmpEntryMainComp = () => {
    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
    }
    const [searchkey,setsearchkey] = useState("")
    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      
      useEffect(() => {
        window.addEventListener('resize', setDimension);
        
        return(() => {
            window.removeEventListener('resize', setDimension);
            
        })
      }, [screenSize])

      const handleInputSearch = (e)=>{
        setsearchkey(e.target.value)
    }
      const [searchpopulatedata,setsearchpopulatedata] = useState({
        headerid:"",
        id:""
    })



    const [id,setid] = useState("")
    const [classcurrent,setclasscurrent] = useState("")
    const [sectioncurrent,setsectioncurrent] = useState("")
    const [semail, setsemail] = useState("")
    const [smobile, setsmobile] = useState("")
    const [smobileres, setsmobileres] = useState("")
    const [resession,setresession] = useState("")
    const [headerid,setheaderid]= useState("")
    
    const [smiddlename,setsmiddlename] = useState("")
    const [ffirstname,setffirstname] = useState("")
    const [fmiddlename,setfmiddlename] = useState("")
    const [flastname,setflastname] = useState("")
    const [lglastname,setlglastname] = useState("")
    const [lgfirstname,setlgfirstname] = useState("")
    const [lgmiddlename,setlgmiddlename] = useState("")
    const [mfirstname,setmfirstname] = useState("")
    const [mmiddlename,setmmiddlename] = useState("")
    const [mlastname,setmlastname] = useState("")
    
    const [nickname,setnickname] = useState("")
    const [gender,setgender] = useState(false)
    
    const [efirstname,setefirstname]= useState("")
    const [emiddlename,setemiddlename]= useState("")
    const [elastname,setelastname]= useState("")
    const [dateofbirthtea,setdateofbirthtea] = useState("")
    
    
    const [labelefirstname,setlabelefirstname]= useState("")
    const [labelelastname,setlabelelastname]= useState("")
    const [labelnickname,setlabelnickname] = useState("")
    const [labelgender,setlabelgender] = useState("")
    const [labeldateofbirthtea,setlabeldateofbirthtea] = useState("")
    
    const [bordernickname,setbordernickname] = useState("")
    const [borderelastname,setborderelastname] = useState(false)    
    const [borderefirstname,setborderefirstname] = useState(false)
    const [bordergender,setbordergender] = useState("")
    const [borderdateofbirthtea,setborderdateifbirthtea] = useState("")

    const [rejoindt,setrejoindt] = useState("")
    const [labelrejoindt,setlabelrejoindt] = useState("")
    const [borderrejoindt,setborderrejoindt] = useState("")
   
    const [joindt,setjoindt] = useState("")
    const [labeljoindt,setlabeljoindt] = useState("")
    const [borderjoindt,setborderjoindt] = useState("")

    const [dobemp,setdobemp] = useState("")
    const [labeldobemp,setlabeldobemp] = useState("")
    const [borderdobemp,setborderdobemp] = useState("")

    const [intime,setintime] = useState("")
    const [labelintime,setlabelintime] = useState("")
    const [borderintime,setborderintime] = useState("")

    const [outtime,setouttime] = useState("")
    const [labelouttime,setlabelouttime] = useState("")
    const [borderouttime,setborderouttime] = useState("")

    const [persontype,setpersontype] = useState("")
    const [labelpersontype,setlabelpersontype] = useState("")
    const [borderpersontype,setborderpersontype] = useState("")

    const [BusinessGroptype,setBusinessGroptype] = useState("")
    const [labelBusinessGroptype,setlabelBusinessGroptype] = useState("")
    const [borderBusinessGroptype,setborderBusinessGroptype] = useState("")

    const [jobenddt,setjobenddt] = useState("")
    const [labeljobenddt,setlabeljobenddt] = useState("")
    const [borderjobenddt,setborderjobenddt] = useState("")

    const [exitreason,setexitreason] = useState("")
    const [labelexitreason,setlabelexitreason] = useState("")
    const [borderexitreason,setborderexitreason] = useState("")

    const [workphone,setworkphone] = useState("")
    const [labelworkphone,setlabelworkphone] = useState("")
    const [borderworkphone,setborderworkphone] = useState("")

    const [resphone,setresphone] = useState("")
    const [labelresphone,setlabelresphone] = useState("")
    const [borderresphone,setborderresphone] = useState("")

    const [mobileemp,setmobileemp] = useState("")
    const [labelmobileemp,setlabelmobileemp] = useState("")
    const [bordermobileemp,setbordermobileemp] = useState("")

    const [email1emp,setemail1emp] = useState("")
    const [labelemail1emp,setlabelemail1emp] = useState("")
    const [borderemail1emp,setborderemail1emp] = useState("")
  
    const [email2emp,setemail2emp] = useState("")
    const [labelemail2emp,setlabelemail2emp] = useState("")
    const [borderemail2emp,setborderemail2emp] = useState("")

    const [unit,setunit] = useState("")
    const [labelunit,setlabelunit] = useState("")
    const [borderunit,setborderunit] = useState("")

    const [department,setdepartment] = useState("")
    const [labeldepartment,setlabeldepartment] = useState("")
    const [borderdepartment,setborderdepartment] = useState("")

    const [designaiton,setdesignation] = useState("")
    const [labeldesignation,setlabeldesignaiotn] =useState("")
    const [borderdesignation,setborderdesignation] = useState("")

    const [campus,setcampus] = useState("")
    const [labelcampus,setlabelcampus] = useState("")
    const [bordsercampus,setbordsercampus] = useState("")

    const [presentadholding,setpresentadholding] = useState("")
    const [presentadroad,setpresentadroad] = useState("")
    const [presentadarea,setpresentadarea] = useState("")
    const [presentpostcode,setpresentpostcode] = useState("")
    const [presentcountry,setpresentcountry] = useState("")
    const [presentdivision,setpresentdivision] = useState("")
    const [presentdistrict,setpresentdistrict] = useState("")
    const [presentthana,setpresentthana] = useState("")
    const [presentCountryId,setpresentCountryId] = useState("")
    const [presentDivisionId,setpresentDivisionId] = useState("")
    const [presentDistrictId,setpresentDistrictId] = useState("")
    const [presentThanaId,setpresentThanaId] = useState("")
    const [permanentCountryId,setpermanentCountryId] = useState("")
    const [permanentDivisionId,setpermanentDivisionId] = useState("")
    const [permanentDistrictId,setpermanentDistrictId] = useState("")
    const [permanentThanaId,setpermanentThanaId] = useState("")
    const [permanentadholding,setpermanentadholding] = useState("")
    const [permanentadroad,setpermanentadroad] = useState("")
    const [permanentadarea,setpermanentadarea] = useState("")
    const [permanentpostcode,setpermanentpostcode] = useState("")
    const [permanentcountry,setpermanentcountry] = useState("")
    const [permanentdivision,setpermanentdivision] = useState("")
    const [permanentdistrict,setpermanentdistrict] = useState("")
    const [permanentthana,setpermanentthana] = useState("")

    const [borderpresentpostcode,setborderpresentpostcode] = useState(false)
    const [borderpresentthana,setborderpresentthana] = useState(false)
    const [borderpresentdistrict,setborderpresentdistrict] = useState(false)
    const [borderpresentdivision,setborderpresentdivision] = useState(false)
    const [borderpresentcountry,setborderpresentcountry] = useState("")
    const [borderpresentarea,setborderpresentarea] = useState(false)
    const [borderpresentroad,setborderpresentroad] = useState(false)
    const [borderpresentadholding,setborderpresentadholding] = useState(false)
    const [borderpermanentpostcode,setborderpermanentpostcode] = useState(false)
    const [borderpermanentthana,setborderpermanentthana] = useState(false)
    const [borderpermanentdistrict,setborderpermanentdistrict] = useState(false)
    const [borderpermanentdivision,setborderpermanentdivision] = useState(false)
    const [borderpermanentcountry,setborderpermanentcountry] = useState(false)
    const [borderpermanentarea,setborderpermanentarea] = useState(false)
    const [borderpermanentroad,setborderpermanentroad] = useState(false)
    const [borderpermanentadholding,setborderpermanentadholding] = useState(false)
    const [labelsetpresentadholding, setlabelsetpresentadholding] = useState("")
    const [labelsetpresentroad, setlabelsetpresentroad] = useState("")
    const [labelsetpresentarea, setlabelsetpresentarea] = useState("")
    const [labelpresentcountry, setlabelpresentcountry] = useState("")
    const [labelpresentdivision, setlabelpresentdivision] = useState("")
    const [labelpresentdistrict, setlabelpresentdistrict] = useState("")
    const [labelpresentthana, setlabelpresentthana] = useState("")
    const [labelpresentpostcode, setlabelpresentpostcode] = useState("")
    const [labelsetpermanentadholding, setlabelsetpermanentadholding] = useState("")
    const [labelsetpermanentroad, setlabelsetpermanentroad] = useState("")
    const [labelsetpermanentarea, setlabelsetpermanentarea] = useState("")
    const [labelpermanentcountry, setlabelpermanentcountry] = useState("")
    const [labelpermanentdivision, setlabelpermanentdivision] = useState("")
    const [labelpermanentdistrict, setlabelpermanentdistrict] = useState("")
    const [labelpermanentthana, setlabelpermanentthana] = useState("")
    const [labelpermanentpostcode, setlabelpermanentpostcode] = useState("")

    const [spfirstname,setspfirstname]= useState("")
    const [spmiddlename,setspmiddlename] = useState("")
    const [splastname,setsplastname] = useState("")
    

    const [borderflastname,setborderflastname] = useState(false)
    const [borderfmiddlename,setborderfmiddlename] = useState(false)
    const [borderffirstname,setborderffirstname] = useState(false)

    const [labelffirstname, setlabelffirstname] = useState("")
    const [labelfmiddlename, setlabelfmiddlename] = useState("")
    const [labelflastname, setlabelflastname] = useState("")

    const [fmobile,setfmobile] = useState()
    const [borderfmobile,setborderfmobile] = useState("")
    const [labelfmobile,setlabelfmobile] = useState("")

    const [fnationalid,setfnationalid] = useState()
    const [borderfnationalid,setborderfnationalid] = useState("")
    const [labelfnationalid,setlabelfnationalid] = useState("")

    const [bordermlastname,setbordermlastname] = useState(false)
    const [bordermmiddlename,setbordermmiddlename] = useState(false)
    const [bordermfirstname,setbordermfirstname] = useState(false)
  
    const [labelmfirstname, setlabelmfirstname] = useState("")
    const [labelmmiddlename, setlabelmmiddlename] = useState("")
    const [labelmlastname, setlabelmlastname] = useState("")
  
    const [mmobile,setmmobile] = useState()
    const [bordermmobile,setbordermmobile] = useState("")
    const [labelmmobile,setlabelmmobile] = useState("")
  
    const [mnationalid,setmnationalid] = useState()
    const [bordermnationalid,setbordermnationalid] = useState("")
    const [labelmnationalid,setlabelmnationalid] = useState("")

    const [labelspfirstname, setlabelspfirstname] = useState("")
    const [labelspmiddlename, setlabelspmiddlename] = useState("")
    const [labelsplastname, setlabelsplastname] = useState("")
    
    const [borderspfirstname, setborderspfirstname] = useState("")
    const [borderspmiddlename, setborderspmiddlename] = useState("")
    const [bordersplastname, setbordersplastname] = useState("")
  
    const [spmobile,setspmobile] = useState()
    const [borderspmobile,setborderspmobile] = useState("")
    const [labelspmobile,setlabelspmobile] = useState("")
  
    const [spnationalid,setspnationalid] = useState()
    const [borderspnationalid,setborderspnationalid] = useState("")
    const [labelspnationalid,setlabelspnationalid] = useState("")

    const [maritalstatus,setmaritalstatus] = useState("")
    const [bordermaritalstatus,setbordermaritalstatus] = useState("")
    const [labelmaritalstatus,setlabelmaritalstatus] = useState("")

    const [noofdependant,setnoofdependant] = useState("")
    const [bordernoofdependant,setbordernoofdependant] = useState("")
    const [labelnoofdependant,setlabelnoofdependant] = useState("")

    const [passportemp,setpassportemp] = useState("")
    const [borderpassportemp,setborderpassportemp] = useState("")
    const [labelpassportemp,setlabelpassportemp] = useState("")

    const [nationalidemp,setnationalidemp] = useState("")
    const [bordernationalidemp,setbordernationalidemp] = useState("")
    const [labelnationalidemp,setlabelnationalidemp] = useState("")

    const [drivinglicensenoemp,setdrivinglicensenoemp] = useState("")
    const [borderdrivinglicensenoemp,setborderdrivinglicensenoemp] = useState("")
    const [labeldrivinglicensenoemp,setlabeldrivinglicensenoemp] = useState("")

    const [signatureemp,setsignatureemp] = useState("")
    const [bordersignatureemp,setbordersignatureemp] = useState("")
    const [labelsignatureemp,setlabelsignatureemp] = useState("")

    const [bloodgroupemp,setbloodgroupemp] = useState("")
    const [borderbloodgroupemp,setborderbloodgroupemp] = useState("")
    const [labelbloodgroupemp,setlabelbloodgroupemp] = useState("")

    const [nationalityemp,setnationalityemp] = useState("")
    const [bordernationalityemp,setbordernationalityemp] = useState("")
    const [labelnationalityemp,setlabelnationalityemp] = useState("")

    const [religionemp,setreligionemp] = useState("")
    const [borderreligionemp,setborderreligionemp] = useState("")
    const [labelreligionemp,setlabelreligionemp] = useState("")

    const [deathdateemp,setdeathdateemp] = useState("")
    const [borderdeathdateemp,setborderdeathdateemp] = useState("")
    const [labeldeathdateemp,setlabeldeathdateemp] = useState("")

    const [birthcountryemp,setbirthcountryemp] = useState("")
    const [borderbirthcountryemp,setborderbirthcountryemp] = useState("")
    const [labelbirthcountryemp,setlabelbirthcountryemp] = useState("")

    const [birthdivisionemp,setbirthdivisionemp] = useState("")
    const [borderbirthdivisionemp,setborderbirthdivisionemp] = useState("")
    const [labelbirthdivisionemp,setlabelbirthdivisionemp] = useState("")

    const [birthcityemp,setbirthcityemp] = useState("")
    const [borderbirthcityemp,setborderbirthcityemp] = useState("")
    const [labelbirthcityemp,setlabelbirthcityemp] = useState("")

    const [birthplaceemp,setbirthplaceemp] = useState("")
    const [borderbirthplaceemp,setborderbirthplaceemp] = useState("")
    const [labelbirthplaceemp,setlabelbirthplaceemp] = useState("")

    const [usernameemp,setusernameemp] = useState("")
    const [borderusernameemp,setborderusernameemp] = useState("")
    const [labelusernameemp,setlabelusernameemp] = useState("")

    const [referrernameemp,setreferrernameemp] = useState("")
    const [borderreferrernameemp,setborderreferrernameemp] = useState("")
    const [labelreferrernameemp,setlabelreferrernameemp] = useState("")


    const [organizationref,setorganizationref] = useState("")
    const [borderorganizationref,setborderorganizationref] = useState("")
    const [labelorganizationref,setlabelorganizationref] = useState("")

    const [designationref,setdesignationref] = useState("")
    const [borderdesignationref,setborderdesignationref] = useState("")
    const [labeldesignationref,setlabeldesignationref] = useState("")

    const [relationref,setrelationref] = useState("")
    const [borderrelationref,setborderrelationref] = useState("")
    const [labelrelationref,setlabelrelationref] = useState("")

    const [address1ref,setaddress1ref] = useState("")
    const [borderaddress1ref,setborderaddress1ref] = useState("")
    const [labeladdress1ref,setlabeladdress1ref] = useState("")

    const [mobile1ref,setmobile1ref] = useState("")
    const [bordermobile1ref,setbordermobile1ref] = useState("")
    const [labelmobile1ref,setlabelmobile1ref] = useState("")

    const [mobile2ref,setmobile2ref] = useState("")
    const [bordermobile2ref,setbordermobile2ref] = useState("")
    const [labelmobile2ref,setlabelmobile2ref] = useState("")

    const [emailref,setemailref] = useState("")
    const [borderemailref,setborderemailref] = useState("")
    const [labelemailref,setlabelemailref] = useState("")

    const [refferIdref,setrefferIdref] = useState("")
    const [borderrefferIdref,setborderrefferIdref] = useState("")
    const [labelrefferIdref,setlabelrefferIdref] = useState("")

    const [proxnum,setproxnum]= useState("")
    const [labelproxnum,setlabelproxnum]= useState("")
    const [borderproxnum,setborderproxnum]= useState("")

    const [qualificationAdd,setqualificationAdd]= useState("")
    const [labelqualificationAdd,setlabelqualificationAdd]= useState("")
    const [borderqualificationAdd,setborderqualificationAdd]= useState("")
  
    const [subjectAdd,setsubjectAdd]= useState("")
    const [labelsubjectAdd,setlabelsubjectAdd]= useState("")
    const [bordersubjectAdd,setbordersubjectAdd]= useState("")

    const [instituteAdd,setinstituteAdd]= useState("")
    const [labelinstituteAdd,setlabelinstituteAdd]= useState("")
    const [borderinstituteAdd,setborderinstituteAdd]= useState("")

    const [boardAdd,setboardAdd]= useState("")
    const [labelboardAdd,setlabelboardAdd]= useState("")
    const [borderboardAdd,setborderboardAdd]= useState("")

    const [resultAdd,setresultAdd]= useState("")
    const [labelresultAdd,setlabelresultAdd]= useState("")
    const [borderresultAdd,setborderresultAdd]= useState("")

    const [passyearAdd,setpassyearAdd]= useState("")
    const [labelpassyearAdd,setlabelpassyearAdd]= useState("")
    const [borderpassyearAdd,setborderpassyearAdd]= useState("")

    const [expCompany,setexpCompany]= useState("")
    const [labelexpCompany,setlabelexpCompany]= useState("")
    const [borderexpCompany,setborderexpCompany]= useState("")

    const [expPosition,setexpPosition]= useState("")
    const [labelexpPosition,setlabelexpPosition]= useState("")
    const [borderexpPosition,setborderexpPosition]= useState("")

    const [expLocation,setexpLocation]= useState("")
    const [labelexpLocation,setlabelexpLocation]= useState("")
    const [borderexpLocation,setborderexpLocation]= useState("")

    const [expResponsibility,setexpResponsibility]= useState("")
    const [labelexpResponsibility,setlabelexpResponsibility]= useState("")
    const [borderexpResponsibility,setborderexpResponsibility]= useState("")

    const [expStartDate,setexpStartDate]= useState("")
    const [labelexpStartDate,setlabelexpStartDate]= useState("")
    const [borderexpStartDate,setborderexpStartDate]= useState("")

    const [expEndDate,setexpEndDate]= useState("")
    const [labelexpEndDate,setlabelexpEndDate]= useState("")
    const [borderexpEndDate,setborderexpEndDate]= useState("")

    const [ExpCompanyValue,setExpCompanyValue] = useState("")
    const [ExpPositionValue,setExpPositionValue] = useState("")
    const [ExpCompanyValueSave,setExpCompanyValueSave] = useState("")
    const [ExpPositionValueSave,setExpPositionValueSave] = useState("")

 
    const drpfuncexpposition=(myval,myid)=>{
        setexpPosition(myval)
        setExpPositionValueSave(myid)
    }
    const drpfuncexpcompany=(myval,myid)=>{
        setexpCompany(myval)
        setExpCompanyValueSave(myid)
    }
    const drpfuncqualificationAdd=(myval,myid)=>{
        setqualificationAdd(myval)
        setQualificaitonValue(myid)
    }
    const drpfuncsubjectAdd=(myval,myid)=>{
        setsubjectAdd(myval)
        setSubjectValue(myid)
    }
    const drpfuncinstituteAdd=(myval,myid)=>{
        setinstituteAdd(myval)
        setInstitutionValue(myid)
    }
    const drpfuncboardAdd=(myval,myid)=>{
        setboardAdd(myval)
        setBoardValue(myid)
    }
    const handleexpStartDate = (newvaldob) => {
        
        if (newvaldob != null) {
            
            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setexpStartDate(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }
    }
    const handleexpEndDate = (newvaldob) => {
        
        if (newvaldob != null) {
            
            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setexpEndDate(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }
    }
    function DrpdownValueSet(res,myval,setter){
        const matchedItem = res.find(
            (item) => (item.id == myval)
            );
            if (matchedItem) {
                setter(matchedItem.opt);
                
            } else {
                setter("");
            }
    }

    const [QualificaitonValue,setQualificaitonValue]= useState("")
    const [SubjectValue,setSubjectValue]= useState("")
    const [InstitutionValue,setInstitutionValue]= useState("")
    const [BoardValue,setBoardValue]= useState("")

    //Employee Qualification
    const handleQauliRowClick=(allDatainRow)=>{
        setQualificaitonValue(allDatainRow.qualiId)
        setSubjectValue(allDatainRow.major)
        setInstitutionValue(allDatainRow.instituteId)
        setBoardValue(allDatainRow.boardId)
        DrpdownValueSet(QulificationResponse,allDatainRow.qualiId,setQulificationNamePopulate)
        DrpdownValueSet(SubjectResponse,allDatainRow.major,settQualificationSubject)
        DrpdownValueSet(InstituteResponse,allDatainRow.instituteId,settQualificationInstitute)
        DrpdownValueSet(BoardResponse,allDatainRow.boardId,settQualificationBoard)
        setpassyearAdd(allDatainRow.passYear)
        setresultAdd(allDatainRow.result)
    }
    const handleAddQuali= async ()=>{
        const addObj = {
            emP_HEADER_ID : headerid,
            qualI_ID : QualificaitonValue,
            major : SubjectValue,
            institutE_ID:InstitutionValue,
            boarD_ID:BoardValue,
            pasS_YEAR:passyearAdd,
            result:resultAdd
        }
        if(headerid=="" && headerid.length==0){
            toast.error("Employee Not Found", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
        }
        else{
           
            if(QulificationNamePopulate &&
                QualificationSubject &&
                QualificationInstitute &&
                QualificationBoard && resultAdd && passyearAdd){
                    await SaveEmpQualification(addObj)
                }
                else{
                    validationDrp(qualificationAdd,setlabelqualificationAdd,setborderqualificationAdd,"Qualification Required")
                    validationDrp(subjectAdd,setlabelsubjectAdd,setbordersubjectAdd,"Subject Required")
                    validationDrp(instituteAdd,setlabelinstituteAdd,setborderinstituteAdd,"Institute Required")
                    validationDrp(boardAdd,setlabelboardAdd,setborderboardAdd,"Board Required")
                    validationComp(resultAdd,setlabelresultAdd,setborderresultAdd,"Result Required")
                    validationComp(passyearAdd,setlabelpassyearAdd,setborderpassyearAdd,"Pass Year Required")

            }

        }
    }
    async function SaveEmpQualification(addObj) {
        try {
          axios.post('https://localhost:7229/api/EmployeeEntry/SaveEmpQualification',addObj, headers)
          .then(function (response) {
            setEmpQualificationResponse(response.data);
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
            
          } else {
            console.error(`Error: ${err.message}`);
          }
         
        }
    }
    //Employee Experience
    const handleExpRowClick=(allDatainRow)=>{
        setExpCompanyValueSave(allDatainRow.companyId)
        setExpPositionValueSave(allDatainRow.positionId)
        DrpdownValueSet(ExpCompanyResponse,allDatainRow.companyId,setExpCompanyValue)
        DrpdownValueSet(PositionResponse,allDatainRow.positionId,setExpPositionValue)
        setexpLocation(allDatainRow.location)
        setexpResponsibility(allDatainRow.responsibility)
        setexpStartDate(allDatainRow.startDate)
        setexpEndDate(allDatainRow.endDate)
    }
    const handleAddEmpExp = async () => {
        const addobj={
            emP_HEADER_ID: headerid,
            companY_ID: ExpCompanyValueSave,
            positioN_ID: ExpPositionValueSave,
            location: expLocation,
            responsibility: expResponsibility,
            starT_DATE: expStartDate,
            enD_DATE: expEndDate
        }
        

        if(headerid=="" && headerid.length==0){
            toast.error("Employee Not Found", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
        }
        else{
            if(ExpCompanyValueSave && ExpPositionValueSave && expLocation && expResponsibility && expStartDate && expEndDate){
                await SaveEmpExperiance(addobj)
            }
            else{
                validationDrp(expCompany,setlabelexpCompany,setborderexpCompany,"Company Required")
                validationDrp(expPosition,setlabelexpPosition,setborderexpPosition,"Position Required")
                validationComp(expLocation,setlabelexpLocation,setborderexpLocation,"Location Required")
                validationComp(expResponsibility,setlabelexpResponsibility,setborderexpResponsibility,"Responsibility Required")
                validationComp(expStartDate,setlabelexpStartDate,setborderexpStartDate,"Start Date Required")
                validationComp(expEndDate,setlabelexpEndDate,setborderexpEndDate,"End Date Required")

            }
        }

    }
    async function SaveEmpExperiance(addobj2){

        try {
            axios.post('https://localhost:7229/api/EmployeeEntry/SaveEmpExperience',addobj2, headers)
            .then(function (response) {
                setEmpExpresponse(response.data);
            });
          } catch (err) {
            if (err.response) {
              console.error(err.response.data);
              console.log(err.response.status);
              console.log(err.response.header);
              
            } else {
              console.error(`Error: ${err.message}`);
            }
           
          }
    } 

    const [isSameaddress,setisSameaddress] = useState("")
    

    const handleSameaddress = event => {
        if (event.target.checked) {
            
            console.log("clicked me?")
            setpermanentadholding(presentadholding)
            setpermanentadarea(presentadarea)
            setpermanentadroad(presentadroad)
            setpermanentpostcode(presentpostcode)
            setpermanentcountry(presentcountry)
            setpermanentdivision(presentdivision)
            setpermanentdistrict(presentdistrict)
            setpermanentthana(presentthana)

            setpermanentCountryId(presentCountryId)
            setpermanentDistrictId(presentDistrictId)
            setpermanentDivisionId(presentDivisionId)
            setpermanentThanaId(presentThanaId)
        } else {
        }
        setisSameaddress(current => !current);
      };
    


    const drpfunctionbirthplaceemp=(myval,myid)=>{
        setbirthplaceemp(myid)
    }
    const drpfunctionbirthcityemp=(myval,myid)=>{
        setbirthcityemp(myid)
    }
    const drpfunctionbirthdivisionemp=(myval,myid)=>{
        setbirthdivisionemp(myid)
    }
    const drpfunctionbirthcountryemp=(myval,myid)=>{
        setbirthcountryemp(myid)
    }
    const drpfunctionreligionemp=(myval,myid)=>{
        setreligionemp(myid)
    }
    const drpfunctionnationalityemp=(myval,myid)=>{
        setnationalityemp(myid)
    }
    const drpfunctionbloodgroupemp=(myval,myid)=>{
        setbloodgroupemp(myid)
    }
    const drpfuncpcountry=(myval,myid)=>{
        setpresentcountry(myval)
        setpresentCountryId(myid)
    }
    const drpfuncpdivision=(myval,myid)=>{
        setpresentdivision(myval)
        setpresentDivisionId(myid)
    }
    const drpfuncpdisctict=(myval,myid)=>{
        setpresentdistrict(myval)
        setpresentDistrictId(myid)
    }
    const drpfuncpthana=(myval,myid)=>{
        setpresentthana(myval)
        setpresentThanaId(myid)
    }
    const drpfuncprcountry=(myval,myid)=>{
        setpermanentcountry(myval)
        setpermanentCountryId(myid)
    }
    const drpfuncprdivision=(myval,myid)=>{
        setpermanentdivision(myval)
        setpermanentDivisionId(myid)
    }
    const drpfuncprdisctict=(myval,myid)=>{
        setpermanentdistrict(myval)
        setpermanentDistrictId(myid)
    }
    const drpfuncprthana=(myval,myid)=>{
        setpermanentthana(myval)
        setpermanentThanaId(myid)
    }




    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
      fileInputRef.current.click();
    };

    const handleRefSaveButtonClick = () => {
      };
  
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      // Do something with the ed file, e.g., upload it or process it
      
    };
  
    

    const drpfunctionmaritalstatus = (myval, myid) => {
        setmaritalstatus(myid)
    }
    const drpfuncdesignation = (myval, myid) => {
        setdesignation(myid)
    }
    const drpfuncCampus = (myval, myid) => {
        setcampus(myid)
    }
    const drpfunctiondepartment = (myval, myid) => {
        setdepartment(myid)
    }
    const drpfunctionunit = (myval, myid) => {
        setunit(myid)
    }
    const drpfunctiongender = (myval, myid) => {
        setgender(myid)
    }
    const drpfunctionpersontype = (myval, myid) => {
        setpersontype(myid)
    }
    const drpfunctionBussinessGrp = (myval, myid) => {
        setBusinessGroptype(myval)
        setbussinessGroupId(myid)
    }

    const handlejobenddt = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setjobenddt(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }
    }
    const handledobemp = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdobemp(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }
    }
    const handledeathdateemp = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdeathdateemp(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }
    }
    const handlerejoindt = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setrejoindt(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }
    }
    const handlejoindt = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setjoindt(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }
    }


    const [chkboxTeacher,setchkboxTeacher] = useState("false")
    const handlechkboxTeacher=(event)=>{
        // if (event.target.checked) {
        //     setchkboxTeacher("true")
        // }
        setchkboxTeacher(!chkboxTeacher);
    }
    const [chkbooxpermanent,setchkbooxpermanent] = useState(false)
    const handlechkbooxpermanent=(event)=>{
        // if (event.target.checked) {
        //     setchkbooxpermanent(true)
        // } 
        setchkbooxpermanent(!chkbooxpermanent);
    }
    const [chkbooxactive,setchkbooxactive] = useState(false)
    const handlechkbooxactive=(event)=>{
        // if (event.target.checked) {
        //     setchkbooxactive(true)
        // } 
        setchkbooxactive(!chkbooxactive);
    }
    const [genderresponse, setgenderrsponse] = useState([]);
    const [persontypeResponse, setpersontypeResponse] = useState([]);
    const [CompanyResponse, setCompanyResponse] = useState([]);
    const [UnitResponse, setUnitResponse] = useState([]);
    const [DepartmentResponse, setDepartmentResponse] = useState([]);
    const [DesignationResponse, setDesignationResponse] = useState([]);
    const [campusresponse, setcampusresponse] = useState([]);
    const [countryresponse, setcountryresponse] = useState([]);
    const [divisionresponse, setdivisionresponse] = useState([]);
    const [districtresponse, setdistrictresponse] = useState([]);
    const [thanaresponse, setthanaresponse] = useState([]);
    const [bloodgroupresponse, setbloodgroupresponse] = useState([]);
    const [religionresponse, setreligionresponse] = useState([]);
    const [nationalityresponse, setnationalityresponse] = useState([]);
    const [maritalstatusresponse, setmaritalstatusresponse] = useState([]);

    const [QulificationResponse, setQulificationResponse] = useState([]);
    const [SubjectResponse, setSubjectResponse] = useState([]);
    const [InstituteResponse, setInstituteResponse] = useState([]);
    const [BoardResponse, setBoardResponse] = useState([]);
    const [ExpCompanyResponse, setExpCompanyResponse] = useState([]);
    const [PositionResponse, setPositionResponse] = useState([]);

    useEffect(() => {
       const fetchGenderdrp = async () => {
        const data = await fetchEmpGenderDropDownn();
        setgenderrsponse(data);
        };
        fetchGenderdrp(); 
      const fetchcampusdrp = async () => {
        const data = await fetchCampusDropdown();
        setcampusresponse(data);
      };
      fetchcampusdrp();

      const fetchPersonType = async () => {
        const data = await fetchPersonTypeDrpDown();
        setpersontypeResponse(data);
      };
      fetchPersonType();

      const fetchUnitdrp = async () => {
        const data = await fetchUnitTypeDrpDown();
        setUnitResponse(data);
      };
      fetchUnitdrp();

      const fetchCompanydrp = async () => {
        const data = await fetchCompanyTypeDrpDown();
        setCompanyResponse(data);
      };
      fetchCompanydrp();

      const fetchDepartmentdrp = async () => {
        const data = await fetchDepartmentTypeDrpDown();
        setDepartmentResponse(data);
      };
      fetchDepartmentdrp();

      const fetchDesignationdrp = async () => {
        const data = await fetchDesignationTypeDrpDown();
        setDesignationResponse(data);
      };
      fetchDesignationdrp();

      const fetchCountrydrp = async () => {
        const data = await fetchCountryDropdown();
        setcountryresponse(data);
      };
      fetchCountrydrp();

      const fetchDivisiondrp = async () => {
        const data = await fetchdivisionDropdown();
        setdivisionresponse(data);
      };
      fetchDivisiondrp();

      const fetchDistrictdrp = async () => {
        const data = await fetchdistrictDropdown();
        setdistrictresponse(data);
      };
      fetchDistrictdrp();

      const fetchThanadrp = async () => {
        const data = await fetchthanaDropdown();
        setthanaresponse(data);
      };
      fetchThanadrp();

      const fetchBloodGrpdrp = async () => {
        const data = await fetchbloodgroupDropdown();
        setbloodgroupresponse(data);
      };
      fetchBloodGrpdrp();

      const fetchNationalitydrp = async () => {
        const data = await fetchnationalityDropdown();
        setnationalityresponse(data);
      };
      fetchNationalitydrp();

      const fetchReligiondrp = async () => {
        const data = await fetchreligionDropdown();
        setreligionresponse(data);
      };
      fetchReligiondrp();

      const fetchmaritalstatusdrp = async () => {
        const data = await fetchMaritalStatusDrpDown();
        setmaritalstatusresponse(data);
      };
      fetchmaritalstatusdrp();

      const fetchQulificationDropDown = async () => {
        const data = await fetchQulificationDrpDown();
        setQulificationResponse(data);
      };
      fetchQulificationDropDown();

      const fetchSubjectDropDown = async () => {
        const data = await fetchSubjectDrpDown();
        setSubjectResponse(data);
      };
      fetchSubjectDropDown();

      const fetchInstituteDropDown = async () => {
        const data = await fetchInstituteDrpDown();
        setInstituteResponse(data);
      };
      fetchInstituteDropDown();

      const fetchBoardDropDown = async () => {
        const data = await fetchBoardDrpDown();
        setBoardResponse(data);
      };
      fetchBoardDropDown();

      const fetchCompanyDropDown = async () => {
        const data = await fetchCompanyDrpDown();
        setExpCompanyResponse(data);
      };
      fetchCompanyDropDown();

      const fetchPositionDropDown = async () => {
        const data = await fetchPositionDrpDown();
        setPositionResponse(data);
      };
      fetchPositionDropDown();
    }, []);

    const [bussinessGroupId,setbussinessGroupId] = useState("")
    const [empSearchInforesponse, setempSearchInforesponse] = useState([]);
    const [EmpInforesponse, setEmpInforesponse] = useState([]);
    const [EmpExpresponse, setEmpExpresponse] = useState([]);
    const [EmpQualificationResponse, setEmpQualificationResponse] = useState([]);
    const [EmpReferenceResponse, setEmpReferenceResponse] = useState([]);
    
    async function SearchEmployeeInfo(SearchKeyWord) {
        try {
          axios.get(`https://localhost:7229/api/EmployeeEntry/GetEmployeeInfoBySearch?searchText=${SearchKeyWord}`, headers)
          .then(function (response) {
            setempSearchInforesponse(response.data);
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
    }
    async function GetEmpDetailsBySelectedRow(HId){
        try {
            axios.get(`https://localhost:7229/api/EmployeeEntry/GetEmployeeInfoBySearchValue?EmpHeaderId=${HId}`, headers)
            .then(function (response) {
              if (response.status == 200){
                    console.log(response.data)
                    setEmpInforesponse(response.data.employee);
                    setEmpExpresponse(response.data.employeeExperience);
                    setEmpReferenceResponse(response.data.employeeRefference);
                    setEmpQualificationResponse(response.data.employeeQualification)
                    console.log(response.data.employeeQualification)
                    PopulateEmpReferenceInfo(response.data.employeeRefference);
                    setsearchkey("")

                    const Employee = response.data.employee;
                    setid(Employee.emP_ID?Employee.emP_ID:"")
                    setheaderid(Employee.emP_HEADER_ID?Employee.emP_HEADER_ID:"")
                    setefirstname(Employee.emP_FIRST_NAME?Employee.emP_FIRST_NAME:"")
                    setemiddlename(Employee.emP_MIDDLE_NAME?Employee.emP_MIDDLE_NAME:"")
                    setelastname(Employee.emP_LAST_NAME?Employee.emP_LAST_NAME:"")
                    setnickname(Employee.emP_NICK_NAME?Employee.emP_NICK_NAME:"")
                    setbussinessGroupId(Employee.businesS_GROUP_ID?Employee.businesS_GROUP_ID:null)
                    setdepartment(Employee.depT_ID? Employee.depT_ID : null)
                    setdesignation(Employee.desiG_ID? Employee.desiG_ID : null)
                    setcampus(Employee.joB_LOCATION_ID? Employee.joB_LOCATION_ID : "")
                    setunit(Employee.uniT_ID? Employee.uniT_ID : null)
                    setgender(Employee.gender)
                    setreligionemp(Employee.religion ? Employee.religion : "")
                    setdobemp(Employee.birtH_DATE?Employee.birtH_DATE:"")
                    setproxnum(Employee.puncH_CARD_ID?Employee.puncH_CARD_ID:"")
                    setintime(Employee.starT_TIME?Employee.starT_TIME:"")
                    setouttime(Employee.enD_TIME?Employee.enD_TIME:"")
                    setjoindt(Employee.joininG_DATE?Employee.joininG_DATE:"")
                    setjobenddt(Employee.joB_END_DATE?Employee.joB_END_DATE:"")
                    setpresentthana(Employee.preS_THANA_ID ? Employee.preS_THANA_ID: null)
                    setpresentdistrict(Employee.preS_CITY_ID ? Employee.preS_CITY_ID: null)
                    setpresentdivision(Employee.preS_DIVISION_ID ? Employee.preS_DIVISION_ID: null)
                    setpresentcountry(Employee.preS_COUNTRY_ID ? Employee.preS_COUNTRY_ID: null)
                    setpresentadholding(Employee.preS_HOLDING_NO?Employee.preS_HOLDING_NO:"")
                    setpresentadroad(Employee.preS_STREET?Employee.preS_STREET:"")
                    setpresentadarea(Employee.preS_AREA?Employee.preS_AREA:"")
                    setpermanentadholding(Employee.perM_HOLDING_NO?Employee.perM_HOLDING_NO:"")
                    setpermanentcountry(Employee.perM_COUNTRY_ID ? Employee.perM_COUNTRY_ID: null)
                    setpermanentdivision(Employee.perM_DIVISION_ID ? Employee.perM_DIVISION_ID: null)
                    setpermanentdistrict(Employee.perM_CITY_ID ? Employee.perM_CITY_ID: null)
                    setpermanentthana(Employee.perM_THANA_ID ? Employee.perM_THANA_ID: null)
                    setpresentpostcode(Employee.preS_POST_CODE?Employee.preS_POST_CODE:"")
                    setpermanentadroad(Employee.perM_STREET?Employee.perM_STREET:"")
                    //setpermanentadholding(Employee.perM_HOLDING_NO?Employee.perM_HOLDING_NO:"")
                    setpermanentadarea(Employee.perM_AREA?Employee.perM_AREA:"")
                    setpermanentpostcode(Employee.perM_POST_CODE?Employee.perM_POST_CODE:"")
                    setworkphone(Employee.worK_PHONE?Employee.worK_PHONE:"")
                    setmobileemp(Employee.mobile?Employee.mobile:"")
                    setresphone(Employee.phone?Employee.phone:"")
                    setemail1emp(Employee.email?Employee.email:"")
                    setemail2emp(Employee.emaiL_2?Employee.emaiL_2:"")
                    setffirstname(Employee.fatheR_FIRST_NAME?Employee.fatheR_FIRST_NAME:"")
                    setfmiddlename(Employee.fatheR_MIDDLE_NAME?Employee.fatheR_MIDDLE_NAME:"")
                    setflastname(Employee.fatheR_LAST_NAME?Employee.fatheR_LAST_NAME:"")
                    setfmobile(Employee.fatheR_CONTACT_NO?Employee.fatheR_CONTACT_NO:"")
                    setfnationalid(Employee.fatheR_NATIONAL_ID?Employee.fatheR_NATIONAL_ID:"")
                    setmfirstname(Employee.motheR_FIRST_NAME?Employee.motheR_FIRST_NAME:"")
                    setmmiddlename(Employee.motheR_MIDDLE_NAME?Employee.motheR_MIDDLE_NAME:"")
                    setmlastname(Employee.motheR_LAST_NAME?Employee.motheR_LAST_NAME:"")
                    setmmobile(Employee.motheR_CONTACT_NO?Employee.motheR_CONTACT_NO:"")
                    setmnationalid(Employee.motheR_NATIONAL_ID?Employee.motheR_NATIONAL_ID:"")
                    setspfirstname(Employee.spousE_FIRST_NAME?Employee.spousE_FIRST_NAME:"")
                    setspmiddlename(Employee.spousE_MIDDLE_NAME?Employee.spousE_MIDDLE_NAME:"")
                    setsplastname(Employee.spousE_LAST_NAME?Employee.spousE_LAST_NAME:"")
                    setspmobile(Employee.spousE_CONTACT_NO?Employee.spousE_CONTACT_NO:"")
                    setspnationalid(Employee.spousE_NATIONAL_ID?Employee.spousE_NATIONAL_ID:"")
                    setnoofdependant(Employee.nO_OF_DEPENDENT?Employee.nO_OF_DEPENDENT:"")
                    setpassportemp(Employee.passporT_NO?Employee.passporT_NO:"")
                    setnationalidemp(Employee.nationaL_ID?Employee.nationaL_ID:"")
                    setdrivinglicensenoemp(Employee.drivinG_LICENSE_NO?Employee.drivinG_LICENSE_NO:"")
                    setsignatureemp(Employee.signature?Employee.signature:"")
                    setdeathdateemp(Employee.deatH_DATE?Employee.deatH_DATE:"")
                    setbirthplaceemp(Employee.placE_OF_BIRTH?Employee.placE_OF_BIRTH:"")
                    setusernameemp(Employee.signature?Employee.signature:"")
                    setbirthcityemp(Employee.birtH_CITY ? Employee.birtH_CITY : "")
                    setbirthcountryemp(Employee.birtH_COUNTRY ? Employee.birtH_COUNTRY : "")
                    setnationalityemp(Employee.nationality ?Employee.nationality : "")
                    setbloodgroupemp(Employee.blooD_GROUP ? Employee.blooD_GROUP :"")
                    setmaritalstatus(Employee.maritaL_STATUS ? Employee.maritaL_STATUS :"")
              }
  
            });
          } catch (err) {
            if (err.response) {
              console.error(err.response.data);
              console.log(err.response.status);
              console.log(err.response.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
    }

    //Populate Employee Reference info
    async function PopulateEmpReferenceInfo(responseInfo){
        setrefferIdref(responseInfo.referrerId)
        setreferrernameemp(responseInfo.referrerName)
        setorganizationref(responseInfo.organization)
        setdesignationref(responseInfo.designation)
        setrelationref(responseInfo.relation)
        setaddress1ref(responseInfo.address1)
        setmobile1ref(responseInfo.mobile1)
        setmobile2ref(responseInfo.mobile2)
        setemailref(responseInfo.email)
    }

    //Drop down data populate method
    const [clrdrp,setclrdrp] = useState(false)
    const [CompanyNamePopulate, setCompanyNamePopulate] = useState("")
    const [GenderValuePopulate, setGenderValuePopulate] = useState("")
    const [CampusValuePopulate, setCampusValuePopulate] = useState("")
    const [UnitValuePopulate, setUnitValuePopulate] = useState("")
    const [DepartmentNamePopulate, setDepartmentNamePopulate] = useState("")
    const [DesignationNamePopulate, setDesignationNamePopulate] = useState("")
    const [PresCountryValuePopulate, setPresCountryValuePopulate] = useState("")
    const [presentdivisionValuePopulate,setpresentdivisionValuePopulate] = useState("")
    const [presentdistrictValuePopulate,setpresentdistrictValuePopulate] = useState("")
    const [presentthanaValuePopulate,setpresentthanaValuePopulate] = useState("")
    const [PermCountryValuePopulate, setPermCountryValuePopulate] = useState("")
    const [permanentdivisionValuePopulate,setpermanentdivisionValuePopulate] = useState("")
    const [permanentdistrictValuePopulate,setpermanentdistrictValuePopulate] = useState("")
    const [permanentthanaValuePopulate,setpermanentthanaValuePopulate] = useState("")
    const [MaritalStatusValuePopulate,setMaritalStatusValuePopulate] = useState("")
    const [bloodgroupValuePopulate,setbloodgroupValuePopulate] = useState("")
    const [nationalityValuePopulate,setnationalityValuePopulate] = useState("")
    const [religionValuePopulate,setreligionValuePopulate] = useState("")
    const [BirthCountryValuePopulate,setBirthCountryValuePopulate] = useState("")
    const [BirthCityValuePopulate,setBirthCityValuePopulate] = useState("")
    const [QulificationNamePopulate, setQulificationNamePopulate] = useState("")
    const [QualificationSubject,settQualificationSubject] = useState("")
    const [QualificationInstitute,settQualificationInstitute] = useState("")
    const [QualificationBoard,settQualificationBoard] = useState("")
    
    useEffect(()=>{
        if(clrdrp==false){
            if(EmpInforesponse.attributE15 == "true") {
                setchkboxTeacher(true);
            }else{
                setchkboxTeacher(false);
            }

            if(EmpInforesponse.iS_PERMENENT == 1) {
                setchkbooxpermanent(true);
            }else{
                setchkbooxpermanent(false);
            }

            if(EmpInforesponse.status == 1) {
                setchkbooxactive(true);
            }else{
                setchkbooxactive(false);
            }
            DrpdownValueSet(CompanyResponse,EmpInforesponse.businesS_GROUP_ID,setCompanyNamePopulate)
            DrpdownValueSet(genderresponse,EmpInforesponse.gender,setGenderValuePopulate)
            DrpdownValueSet(DepartmentResponse,EmpInforesponse.depT_ID,setDepartmentNamePopulate)
            DrpdownValueSet(DesignationResponse,EmpInforesponse.desiG_ID,setDesignationNamePopulate)
            DrpdownValueSet(campusresponse,EmpInforesponse.joB_LOCATION_ID,setCampusValuePopulate)
            DrpdownValueSet(UnitResponse,EmpInforesponse.uniT_ID,setUnitValuePopulate)
            DrpdownValueSet(countryresponse,EmpInforesponse.preS_COUNTRY_ID,setPresCountryValuePopulate)
            DrpdownValueSet(divisionresponse,EmpInforesponse.preS_DIVISION_ID,setpresentdivisionValuePopulate)
            DrpdownValueSet(districtresponse,EmpInforesponse.preS_CITY_ID,setpresentdistrictValuePopulate)
            DrpdownValueSet(thanaresponse,EmpInforesponse.preS_THANA_ID,setpresentthanaValuePopulate)
            DrpdownValueSet(countryresponse,EmpInforesponse.perM_COUNTRY_ID,setPermCountryValuePopulate)
            DrpdownValueSet(divisionresponse,EmpInforesponse.perM_DIVISION_ID,setpermanentdivisionValuePopulate)
            DrpdownValueSet(districtresponse,EmpInforesponse.perM_CITY_ID,setpermanentdistrictValuePopulate)
            DrpdownValueSet(thanaresponse,EmpInforesponse.perM_THANA_ID,setpermanentthanaValuePopulate)
            DrpdownValueSet(maritalstatusresponse,EmpInforesponse.maritaL_STATUS,setMaritalStatusValuePopulate)
            DrpdownValueSet(bloodgroupresponse,EmpInforesponse.blooD_GROUP,setbloodgroupValuePopulate)
            DrpdownValueSet(religionresponse,EmpInforesponse.religion,setreligionValuePopulate)
            DrpdownValueSet(nationalityresponse,EmpInforesponse.nationality,setnationalityValuePopulate)
            DrpdownValueSet(countryresponse,EmpInforesponse.birtH_COUNTRY,setBirthCountryValuePopulate)
            DrpdownValueSet(districtresponse,EmpInforesponse.birtH_CITY,setBirthCityValuePopulate)
            
        }
      },[EmpInforesponse,clrdrp])
      //nowhere
    const handleClearBtn=()=>{
        setEmpInforesponse([])
        setEmpExpresponse([])
        setEmpQualificationResponse([])
        setEmpReferenceResponse([])
        setfmobile("")
        setfnationalid("")
        setmmobile("")
        setmnationalid("")
        setdeathdateemp("")
        setdobemp("")
        setjoindt("")
        setnationalidemp("")
        setreferrernameemp("")
        setorganizationref("")
        setdesignationref("")
        setrelationref("")
        setmobile1ref("")
        setmobile2ref("")
        setemailref("")
        setrefferIdref("")
        setpresentadholding("")
        setpresentadroad("")
        setpresentadarea("")
        setpresentpostcode("")
        setpermanentadholding("")
        setpermanentadroad("")
        setpermanentadarea("")
        setpermanentpostcode("")
        setefirstname("")
        setemiddlename("")
        setelastname("")
        setnickname("")
        setgender("")
        setCompanyNamePopulate("")
        setGenderValuePopulate("")
        setCampusValuePopulate("")
        setUnitValuePopulate("")
        setDepartmentNamePopulate("")
        setDesignationNamePopulate("")
        setPresCountryValuePopulate("")
        setpresentdivisionValuePopulate("")
        setpresentdistrictValuePopulate("")
        setpresentthanaValuePopulate("")
        setPermCountryValuePopulate("")
        setpermanentdivisionValuePopulate("")
        setpermanentdistrictValuePopulate("")
        setpermanentthanaValuePopulate("")
        setMaritalStatusValuePopulate("")
        setbloodgroupValuePopulate("")
        setnationalityValuePopulate("")
        setreligionValuePopulate("")
        setBirthCountryValuePopulate("")
        setBirthCityValuePopulate("")
        setQulificationNamePopulate("")
        settQualificationSubject("")
        settQualificationInstitute("")
        settQualificationBoard("")
        setpermanentCountryId("")
        setpermanentDistrictId("")
        setpermanentDivisionId("")
        setpermanentThanaId("")
        setpresentCountryId("")
        setpresentDistrictId("")
        setpresentDivisionId("")
        setpresentThanaId("")
        setpermanentcountry("")
        setpermanentdivision("")
        setpermanentdistrict("")
        setpermanentthana("")
        setpresentcountry("")
        setpresentdivision("")
        setpresentdistrict("")
        setpresentthana("")
        setid("")
        setclasscurrent("")
        setsectioncurrent("")
        setsemail("")
        setsmobile("")
        setsmobileres("")
        setresession("")
        setheaderid("")
        setffirstname("")
        setfmiddlename("")
        setflastname("")
        setlglastname("")
        setlgfirstname("")
        setlgmiddlename("")
        setmfirstname("")
        setmmiddlename("")
        setmlastname("")
        setdateofbirthtea("")
        setrejoindt("")
        setjoindt("")
        setdobemp("")
        setintime("")
        setouttime("")
        setpersontype("")
        setBusinessGroptype("")
        setjobenddt("")
        setexitreason("")
        setworkphone("")
        setresphone("")
        setmobileemp("")
        setemail1emp("")
        setemail2emp("")
        setunit("")
        setdepartment("")
        setdesignation("")
        setcampus("")
    }

    const handleSave=()=>{
            let isFormvalid = false 
            const validationResults = [];
            console.log(department)
            validationResults.push(validationComp(efirstname,setlabelefirstname,setborderefirstname,"First Name Required"))
            validationResults.push(validationComp(elastname,setlabelelastname,setborderelastname,"Last Name Required") )
            validationResults.push(validationComp(dobemp,setlabeldobemp,setborderdobemp,"Date of Birth Required"))
            validationResults.push(validationComp(proxnum,setlabelproxnum,setborderproxnum,"Prox. Num Required"))
            validationResults.push(validationComp(mobileemp,setlabelmobileemp,setbordermobileemp,"Mobile Num Required"))
            validationResults.push(validationComp(email1emp,setlabelemail1emp,setborderemail1emp,"Email 1 Required","emailtype") )
            validationResults.push(validationDrp(department,setlabeldepartment,setborderdepartment,"Department Required") )
            validationResults.push(validationComp(nationalidemp,setlabelnationalidemp,setbordernationalidemp,"National ID Required") )
            validationResults.push(validationComp(intime,setlabelintime,setborderintime,"Required",""))
            validationResults.push(validationComp(outtime,setlabelouttime,setborderouttime,"Required","") )
            isFormvalid = validationResults.every(item=> item === true)

            if(isFormvalid){
                //here
                const finalArr={
                        "emP_HEADER_ID": headerid?headerid:null,
                        "emP_ID": id,
                        "emP_FIRST_NAME": efirstname,
                        "emP_MIDDLE_NAME": emiddlename,
                        "emP_LAST_NAME": elastname,
                        "emP_NICK_NAME": nickname,
                        "businesS_GROUP_ID": bussinessGroupId,
                        "depT_ID": department,
                        "desiG_ID": designaiton,
                        "puncH_CARD_ID": proxnum,
                        "starT_TIME": intime,
                        "enD_TIME": outtime,
                        "joininG_DATE": joindt?joindt :null,
                        "joB_END_DATE": jobenddt?jobenddt: null,
                        "iS_PERMENENT": chkbooxpermanent,
                        "status": chkbooxactive,
                        "birtH_DATE": dobemp?dobemp : null,
                        "deatH_DATE": deathdateemp?deathdateemp:null,
                        "joB_LOCATION_ID": campus?campus:null,
                        "uniT_ID": unit?unit:null,
                        "preS_HOLDING_NO": presentadholding,
                        "preS_STREET": presentadroad,
                        "preS_AREA": presentadarea,
                        "preS_THANA_ID": EmpInforesponse.preS_THANA_ID?EmpInforesponse.preS_THANA_ID:presentThanaId?presentThanaId:null,
                        "preS_POST_CODE": presentpostcode,
                        "preS_DIVISION_ID": EmpInforesponse.preS_DIVISION_ID?EmpInforesponse.preS_DIVISION_ID:presentDivisionId?presentDivisionId:null,
                        "preS_CITY_ID": EmpInforesponse.preS_CITY_ID?EmpInforesponse.preS_CITY_ID:presentDistrictId?presentDistrictId:null,
                        "preS_COUNTRY_ID": EmpInforesponse.preS_COUNTRY_ID?EmpInforesponse.preS_COUNTRY_ID:presentCountryId?presentCountryId:null,
                        "perM_HOLDING_NO": permanentadholding,
                        "perM_STREET": permanentadroad,
                        "perM_AREA": permanentadarea,                        
                        "perM_THANA_ID": EmpInforesponse.perM_THANA_ID?EmpInforesponse.perM_THANA_ID:permanentThanaId?permanentThanaId:null,
                        "perM_POST_CODE": permanentpostcode,
                        "perM_CITY_ID":  EmpInforesponse.perM_CITY_ID?EmpInforesponse.perM_CITY_ID:permanentDistrictId?permanentDistrictId:null,
                        "perM_DIVISION_ID":EmpInforesponse.perM_DIVISION_ID?EmpInforesponse.perM_DIVISION_ID:permanentDivisionId?permanentDivisionId:null,
                        "perM_COUNTRY_ID":  EmpInforesponse.perM_COUNTRY_ID?EmpInforesponse.perM_COUNTRY_ID:permanentCountryId?permanentCountryId:null,
                        "gender": gender,
                        "religion": religionemp,
                        "placE_OF_BIRTH": birthplaceemp,
                        "birtH_COUNTRY": birthcountryemp?birthcountryemp:null,
                        "birtH_CITY": birthcityemp?birthcityemp:null,
                        "nationality": nationalityemp,
                        "passporT_NO": passportemp,
                        "nationaL_ID": nationalidemp,
                        "drivinG_LICENSE_NO": drivinglicensenoemp,
                        "blooD_GROUP": bloodgroupemp,
                        "maritaL_STATUS": maritalstatus? maritalstatus : "",
                        "worK_PHONE": workphone,
                        "mobile": mobileemp,
                        "phone": workphone,
                        "email": email1emp,
                        "emaiL_2": email2emp,
                        "fatheR_FIRST_NAME": ffirstname,
                        "fatheR_MIDDLE_NAME": fmiddlename,
                        "fatheR_LAST_NAME": flastname,
                        "fatheR_CONTACT_NO": fmobile?fmobile:"",
                        "fatheR_NATIONAL_ID": fnationalid?fnationalid: "",
                        "motheR_FIRST_NAME": mfirstname,
                        "motheR_MIDDLE_NAME": mmiddlename,
                        "motheR_LAST_NAME": mlastname,
                        "motheR_CONTACT_NO": mmobile?mmobile:"",
                        "motheR_NATIONAL_ID": mnationalid?mnationalid:"",
                        "spousE_FIRST_NAME": spfirstname,
                        "spousE_MIDDLE_NAME":spmiddlename,
                        "spousE_LAST_NAME": splastname,
                        "spousE_CONTACT_NO": spmobile ? spmobile :"",
                        "spousE_NATIONAL_ID": spnationalid? spnationalid: "",
                        "nO_OF_DEPENDENT": noofdependant ? noofdependant : 0,
                        "signature": signatureemp? signatureemp : "",
                        "attributE2": exitreason,
                        "attributE15": chkboxTeacher.toString(),
                        "rejoininG_DATE": rejoindt ? rejoindt : null

                        //"attributE10": picture image,
                        // "imG_URL": "string",
                        // "applicanT_ID": 0,
                        // "basE_OFFICE_ID": 0,
                        // "internaL_LOCATION_ID": 0,
                }
                const ReferenceArr ={
                    "referencE_ID": refferIdref?refferIdref:null,
                    "referencE_NAME": referrernameemp,
                    "designation": designationref,
                    "addresS1": address1ref,
                    "mobilE1": mobile1ref,
                    "mobilE2": mobile2ref,
                    "email": emailref,
                    "relation": relationref,
                    "attributE1": organizationref
                }
                const data = {
                    _employeeInfo: finalArr,
                    _employeeReferenceInfo: ReferenceArr
                  };
                console.log(data)
                axios.post('https://localhost:7229/api/EmployeeEntry/SaveEmployee', data, headers)
                    .then((response) => {
                    console.log(response);
                    const foundErrorItem = response.data.find(item => item.errorMsg.length > 0);
                    const foundSuccessItem = response.data.find(item => item.successMsg.length > 0);

                    if (foundErrorItem) {
                      toast.error(foundErrorItem.errorMsg, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                      });
                    }
                    if (foundSuccessItem) {
                      toast.success(foundSuccessItem.successMsg, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                      });
                    }
                    })
                    .catch((error) => {
                    console.error(error);
                });
            }
            else{
                toast.error('Error: Required field empty', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }

    }
    const handleLookupentry=()=>{
    }
    const handleSearchButton= async ()=>{
        await SearchEmployeeInfo(searchkey);
    }
    const handleJoiningreport=()=>{

    }
    const notification = {
        notification:true
    }
    const handleRowClick=async (myitem)=>{
        await GetEmpDetailsBySelectedRow(myitem.empHeaderId)
    }
    

  return (
    <div className="f-flex flexvaluecomp stuentrymain">
    <SidebarOfAdash/>
    <ToastContainer
            
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            />
    <div className="contentpartwidthwrapper" style={screenSize.dynamicHeight<925 ? {marginBottom:"75px"}:{}}>
       
    
    <div className=" contentflexvalue billcontent newadmissionentry">
    <div className="bottombarofsave">
            <div className="wrapperemp newadmissionentrywrapemp">
            <button onClick={handleLookupentry}>Look Up Entry</button>
            <button onClick={handleJoiningreport} >Joining Details Report</button>
            <button className='red' onClick={handleClearBtn}>Clear</button>
            
            <button className='red green' onClick={handleSave}>Save</button>
            
            </div>
        </div>
    <div className="headerofadash billpart">
        <div className="left">
            <div className="leftsidesearch">
                <input type="text" value={searchkey} onChange={handleInputSearch} name="searchword" placeholder='Search Employee'/>
                <span onClick={handleSearchButton}>
                    <img src="./assets/images/dashboards/adminDashboard/bill/searchbutton.png" alt="" />
                </span>
            <div className= {searchkey.length>0?"searchtable d-block big":"searchtable d-none big"}>
            <div className="wrapper">

                <div className="billentrytoptable billinfohistorytable searchtablediv empentry">
                <table>
                    <thead>
                    <tr>                                
                    {
                        searchEmptableApi.heading.map((item,key)=>{
                            return(
                                <th key={key}>{item.head}</th>
                            )
                        })
                    }
                </tr>
                    </thead>
                <tbody>

                {
                    empSearchInforesponse ? empSearchInforesponse.map((item,key)=>{
                        return(
                            <tr style={{cursor:"pointer"}} onClick={()=>handleRowClick(item)}>
                              
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                <td>{item.designation}</td>
                                <td>{item.email}</td>
                                 
                            </tr>
                        )
                        
                    }) : "string"
                }
                </tbody>
                </table>

                </div>
                </div>
            </div>
            </div>

        </div>
        <div className="right">
            {
                notification.notification==true?
                <div className="belldiv">
                    <BiBell/>
                </div>
                :
                <BiBell/>
             }
            <div className="displaypic">
                <img src="./assets/images/dashboards/adminDashboard/header/DP.png" alt="" />
            </div>
            <div className="nameandid">
                <h5>{adminHeaderApi.name}</h5>
                <p>ID {adminHeaderApi.id}</p>
            </div>
        </div>
    </div>
    <div className={screenSize.dynamicWidth>1200? "stumainentrybox":"stuforlgdevice"}>
                <h3>Employee Entry</h3>
                <div className="whitebox pb0">

                    <Row>
                        <Col lg={5} className="pr7">
                            <Row>
                            <Col lg={12}>
                            <div className="studentinfo">
                        <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                            <div className="titlewithwhite">
                                <p>Employee</p>
                            </div>

                            <Row>
                                <Col lg={6} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>ID</p>
                                        <div className="inputgap h35">
                                            <input disabled type="text" value={id} onChange={(e) => setid(e.target.value)} />
                                            
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} className='pl5'>
                                    <div className="basicinputfield h35p">
                                        <p>Header ID</p>
                                        <div className="inputgap h35">
                                            <input disabled  type="text" value={headerid} onChange={(e) => setheaderid(e.target.value)} />
                                            
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pe-0'>
                                    <div className="basicinputfield h35p">
                                        <p>First Name</p>
                                        <div className="inputgap h35">
                                            <input style={borderefirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={efirstname} onChange={(e) => setefirstname(e.target.value)} />
                                            <label>{labelefirstname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='px10'>
                                    <div className="basicinputfield h35p">
                                        <p>Middle Name</p>
                                        <div className="inputgap h35">
                                            <input   type="text" value={emiddlename} onChange={(e) => setemiddlename(e.target.value)} />
                                            {/* <label>{labelsmiddlename}</label> */}
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='ps-0'>
                                    <div className="basicinputfield h35p">
                                        <p>Last Name</p>
                                        <div className="inputgap h35">
                                            <input style={borderelastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={elastname} onChange={(e) => setelastname(e.target.value)} />
                                            <label>{labelelastname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>Nick Name</p>
                                        <div className="inputgap h35">
                                            <input style={bordernickname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={nickname} onChange={(e) => setnickname(e.target.value)} />
                                            <label>{labelnickname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pl5 pr5'>
                                <div className="basicinputfield h35p">
                                    <p>Gender</p>
                                    <div className="inputgap h35">
                                        <div className="dropdownwrapper">
                                            <Dropdown2 err={bordergender} func={drpfunctiongender} myplaceholder={GenderValuePopulate}fontsize="12" fontfamily="'Poppins', sans-serif" options={genderresponse} />
                                        </div>
                                        <label>{labelgender}</label>
                                        
                                    </div>
                                </div>
                                </Col>
                                <Col lg={4} className="d-flex align-items-center pl5">
                                <div className="checkboxfull d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        value={chkboxTeacher}
                                        onChange={handlechkboxTeacher}
                                        id="remember"
                                        name="subscribe"
                                        checked={chkboxTeacher}
                                        style={{width:"20px",height:"20px"}}
                                    />
                                    <span style={{marginTop:"6px",display:"inlineblock"}}>Teacher</span>
                                </div>
                    </Col>
                    <Col lg={6} className="pr5">
                    <div className="basicinputfield h35p">
                        <p>Date of Birth</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <div className="inputgap h35">

                                <DatePicker

                                    value={dobemp}
                                    onChange={(newvaldob) => handledobemp(newvaldob)}
                                    renderInput={(params) => 
                                    <TextField style={borderdobemp==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                        ...params.inputProps,
                                        placeholder: ""
                                    }} error={false} />}
                                />
                                <label>{labeldobemp}</label>
                                
                                
                            </div>
                        </LocalizationProvider>
                    </div>
                    </Col>
                   
                           
                        </Row>
                        </div>
                     
                                <div className="studentinfo">
                                    <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                                        <div className="titlewithwhite">
                                            <p>Contact Info</p>
                                        </div>
                                        <Row>
                                        <Col lg={6} className='pr5'>
                                        <div className="basicinputfield h35p">
                                            <p>Work Phone</p>
                                            <div className="inputgap h35">
                                                <input style={borderworkphone ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={workphone} onChange={(e) => setworkphone(e.target.value)} />
                                                
                                                </div>
                                            </div>
                                        </Col>

                                        <Col lg={6} className='pl5'>
                                        <div className="basicinputfield h35p">
                                            <p>Mobile</p>
                                            <div className="inputgap h35">
                                                <input style={bordermobileemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={mobileemp} onChange={(e) => setmobileemp(e.target.value)} />
                                                <label>{labelmobileemp}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={6} className='pr5'>
                                        <div className="basicinputfield h35p">
                                            <p>Res Phone</p>
                                            <div className="inputgap h35">
                                                <input style={borderresphone ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={resphone} onChange={(e) => setresphone(e.target.value)} />
                                                
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={12} >
                                        <div className="basicinputfield h35p">
                                            <p>Emial1</p>
                                            <div className="inputgap h35">
                                                <input style={borderemail1emp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={email1emp} onChange={(e) => setemail1emp(e.target.value)} />
                                                <label>{labelemail1emp}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={12} >
                                        <div className="basicinputfield h35p">
                                            <p>Emial2</p>
                                            <div className="inputgap h35">
                                                <input style={borderemail2emp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={email2emp} onChange={(e) => setemail2emp(e.target.value)} />
                                                
                                                </div>
                                            </div>
                                        </Col>

                                        </Row>

                                    </div>
                                </div>
                          
                            </div>
                            
                            </Col>
                        
                        </Row>
                    </Col>
                    <Col lg={5} className='pr7 pl7'>
                    <Row>
                        <Col lg={12}>
                            <div className="studentinfo">
                                <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                                    <div className="titlewithwhite">
                                        <p>Basic Info</p>
                                    </div>

                                    <Row>
                                    <Col lg={6} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>Prox Number</p>
                                        <div className="inputgap h35">
                                            <input style={borderproxnum ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={proxnum} onChange={(e) => setproxnum(e.target.value)} />
                                            <label>{labelproxnum}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} className='pl5'>
                                <div className="basicinputfield h35p">
                                <p>Re Join Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={rejoindt}
                                            onChange={(newvaldob) => handlerejoindt(newvaldob)}
                                            renderInput={(params) => 
                                            <TextField style={borderrejoindt==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labelrejoindt}</label>
                                        
                                        
                                    </div>
                                        </LocalizationProvider>
                                    </div>
                            </Col>
                                <Col lg={6} className='pr5'>
                                <div className="basicinputfield h35p">
                                <p>Joining Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={joindt}
                                            onChange={(newvaldob) => handlejoindt(newvaldob)}
                                            renderInput={(params) => 
                                            <TextField style={borderjoindt==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeljoindt}</label>
                                        
                                        
                                    </div>
                                        </LocalizationProvider>
                                    </div>
                                    </Col>

                                    <Col lg={6} className='pl5'>
                                    <div className="basicinputfield h35p">
                                        <p>Person Type</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper">
                                                <Dropdown2 err={borderpersontype} func={drpfunctionpersontype} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={persontypeResponse} />
                                            </div>
                                            <label>{labelpersontype}</label>
                                            
                                        </div>
                                    </div>
                                    </Col>

                                    <Col lg={3} className='pr5'>
                                        <div className="basicinputfield h35p">
                                            <p>In Time</p>
                                            <div className="inputgap h35">
                                                <input style={borderintime ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={intime} onChange={(e) => setintime(e.target.value)} />
                                                <label>{labelintime}</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='pr5 pl5'>
                                        <div className="basicinputfield h35p">
                                            <p>Out Time</p>
                                            <div className="inputgap h35">
                                                <input style={borderouttime ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={outtime} onChange={(e) => setouttime(e.target.value)} />
                                                <label>{labelouttime}</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='pl5'>
                                    <div className="basicinputfield h35p">
                                    <p>Job End Date</p>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div className="inputgap h35">
                                            <DatePicker
                                                value={jobenddt}
                                                onChange={(newvaldob) => handlejobenddt(newvaldob)}
                                                renderInput={(params) => 
                                                <TextField style={borderjobenddt==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                    ...params.inputProps,
                                                    placeholder: ""
                                                }} error={false} />}
                                            />
                                            <label>{labeljobenddt}</label>                                            
                                        </div>
                                        </LocalizationProvider>
                                    </div>
                                    </Col>
                                    <Col lg={12}>
                                        <div className="basicinputfield h35p">
                                            <p>Exit Reason</p>
                                            <div className="inputgap h35">
                                                <input style={borderexitreason ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={exitreason} onChange={(e) => setexitreason(e.target.value)} />
                                                <label>{labelexitreason}</label>
                                            </div>
                                        </div>
                                    </Col>
                                    </Row>
                                    
                                </div>
                            </div>
                            <div className="studentinfo">
                                <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                                    <div className="titlewithwhite">
                                        <p>Working Info</p>
                                    </div>
                                    <Row>
                                    <Col lg={12}>
                                    <div className="basicinputfield h35p">
                                        <p>Company</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper">
                                                <Dropdown2 err={borderBusinessGroptype} func={drpfunctionBussinessGrp} myplaceholder={CompanyNamePopulate}fontsize="12" fontfamily="'Poppins', sans-serif" options={CompanyResponse} />
                                            </div>
                                            <label>{labelBusinessGroptype}</label>
                                            
                                        </div>
                                    </div>
                                    </Col>
                                    <Col lg={4} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>Unit</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper">
                                                <Dropdown2 err={borderunit} func={drpfunctionunit} myplaceholder={UnitValuePopulate}fontsize="12" fontfamily="'Poppins', sans-serif" options={UnitResponse} />
                                            </div>
                                            <label>{labelunit}</label>
                                            
                                        </div>
                                    </div>
                                    </Col>
                                    <Col lg={8} className='pl5'>
                                    <div className="basicinputfield h35p">
                                        <p>Department</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper">
                                                <Dropdown2 err={borderdepartment} func={drpfunctiondepartment} myplaceholder={DepartmentNamePopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={DepartmentResponse} />
                                            </div>
                                            <label>{labeldepartment}</label>
                                            
                                        </div>
                                    </div>
                                    </Col>
                                      <Col lg={12} >
                                    <div className="basicinputfield h35p">
                                        <p>Designation</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper">
                                                <Dropdown2 err={borderdesignation} func={drpfuncdesignation} myplaceholder={DesignationNamePopulate}fontsize="12" fontfamily="'Poppins', sans-serif" options={DesignationResponse} />
                                            </div>
                                            <label>{labeldesignation}</label>
                                            
                                        </div>
                                    </div>
                                    </Col>
                                      <Col lg={4} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>Campus</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper">
                                                <Dropdown2 err={borderdesignation} func={drpfuncCampus} myplaceholder={CampusValuePopulate}fontsize="12" fontfamily="'Poppins', sans-serif" options={campusresponse} />
                                            </div>
                                            <label>{labeldesignation}</label>
                                            
                                        </div>
                                    </div>
                                    </Col>
                                    <Col lg={4} className="d-flex align-items-center pl5">
                                <div className="checkboxfull d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        value={chkbooxpermanent}
                                        onChange={handlechkbooxpermanent}
                                        id="remember"
                                        name="subscribe"
                                        checked={chkbooxpermanent}
                                        style={{width:"20px",height:"20px"}}
                                    />
                                    <span style={{marginTop:"6px",display:"inlineblock",fontSize:"12px"}}>Permanent</span>
                                </div>
                            </Col>
                                    <Col lg={4} className="d-flex align-items-center pl5">
                                <div className="checkboxfull d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        value={chkbooxactive}
                                        onChange={handlechkbooxactive}
                                        id="remember"
                                        name="subscribe"
                                        checked={chkbooxactive}
                                        style={{width:"20px",height:"20px"}}
                                    />
                                    <span style={{marginTop:"6px",display:"inlineblock",fontSize:"12px"}}>Active</span>
                                </div>
                            </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                        
                    </Row>

                   

                    </Col>
                    <Col lg={2} className="pl7">
                        <div className="imgstu">
                        <div className="overlay">
                            <input
                                type="file"
                                accept="image/*" // Use appropriate MIME types if you have a specific file type in mind
                                style={{ display: 'none' }} // Hide the default file input
                                ref={fileInputRef}
                                onChange={handleFileChange}
                            />
                            <Purplebutton clickfunc={handleButtonClick} btnname="Browse" w="117px" h="40px" mt="0px"/>
                            </div>
                        <img className='w-100' src="./assets/images/dashboards/adminDashboard/employee/employeepic.png" alt="" />
                       

                        </div>
                    </Col>
                </Row>
                </div>
                <div className={screenSize.dynamicWidth>1200? "stumainentrybox":"stuforlgdevice"}>
                
                <div className="whitebox mt15 tabsofstuentry mb90">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                    <Col sm={12}>
                    <Nav variant="pills" className="flex-row justify-content-center">
                        <Nav.Item>
                        <Nav.Link eventKey="first">Address</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="second">Family Information</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="third">Other's Information</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="fourth">Reference</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="fifth">Qualification</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="sixth">Experience</Nav.Link>
                        </Nav.Item>
                       
                    </Nav>
                    </Col>
                    <Col sm={12}>
                        <Tab.Content>
                        <Tab.Pane eventKey="first" className="px75">
                            <div className="stumainentrybox2">
                                    <Row>
                                        <Col lg={6} className="pr7">
                                        <div className="billbox paymentcollectbox stuCommonformbox presentaddbox" >
                                            <div className="titlewithwhite">
                                                <p>Present Address</p>
                                            </div>

                                            <Row>
                                            <Col lg={4} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Holding</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentadholding ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentadholding} onChange={(e) => setpresentadholding(e.target.value)} />
                                                    <label>{labelsetpresentadholding}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={8} className='pl5'>
                                            <div className="basicinputfield h35p">
                                                <p>Road</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentroad ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentadroad} onChange={(e) => setpresentadroad(e.target.value)} />
                                                    <label>{labelsetpresentroad}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={8} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Area</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentarea ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentadarea} onChange={(e) => setpresentadarea(e.target.value)} />
                                                    <label>{labelsetpresentarea}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} className='pl5'>
                                            <div className="basicinputfield h35p">
                                                <p>Post Code</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentpostcode ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentpostcode} onChange={(e) => setpresentpostcode(e.target.value)} />
                                                    <label>{labelpresentpostcode}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} className='pr5'>
                                        <div className="basicinputfield h35p">
                                            <p>Country</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentcountry} func={drpfuncpcountry} myplaceholder={PresCountryValuePopulate?PresCountryValuePopulate:presentcountry}fontsize="12" fontfamily="'Poppins', sans-serif" options={countryresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                        <Col lg={4} className='pr5 pl5'>
                                        <div className="basicinputfield h35p">
                                            <p>Division</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentdivision} func={drpfuncpdivision} myplaceholder={presentdivisionValuePopulate?presentdivisionValuePopulate:presentdivision} fontsize="12" fontfamily="'Poppins', sans-serif" options={divisionresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                        <Col lg={4} className='pl5'>
                                        <div className="basicinputfield h35p">
                                            <p>District</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentdistrict} func={drpfuncpdisctict} myplaceholder={presentdistrictValuePopulate?presentdistrictValuePopulate:presentdistrict}fontsize="12" fontfamily="'Poppins', sans-serif" options={districtresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                        <Col lg={4} className='pr5'>
                                        <div className="basicinputfield h35p">
                                            <p>Thana</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentthana} func={drpfuncpthana} myplaceholder={presentthanaValuePopulate?presentthanaValuePopulate:presentthana} fontsize="12" fontfamily="'Poppins', sans-serif" options={thanaresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                            </Row>
                                        </div>
                                        </Col>
                                        <Col lg={6} className="pl7">
                                        <div className="billbox paymentcollectbox stuCommonformbox">
                                            <div className="titlewithwhite">
                                                <p>permanent Address</p>
                                            </div>

                                            <Row>
                                            <Col lg={4} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Holding</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpermanentadholding ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentadholding} onChange={(e) => setpermanentadholding(e.target.value)} />
                                                    <label>{labelsetpermanentadholding}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={8} className='pl5'>
                                            <div className="basicinputfield h35p">
                                                <p>Road</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpermanentroad ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentadroad} onChange={(e) => setpermanentadroad(e.target.value)} />
                                                    <label>{labelsetpermanentroad}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={8} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Area</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpermanentarea ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentadarea} onChange={(e) => setpermanentadarea(e.target.value)} />
                                                    <label>{labelsetpermanentarea}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} className='pl5'>
                                            <div className="basicinputfield h35p">
                                                <p>Post Code</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpermanentpostcode ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentpostcode} onChange={(e) => setpermanentpostcode(e.target.value)} />
                                                    <label>{labelpermanentpostcode}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>Country</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={borderpermanentcountry} func={drpfuncprcountry} myplaceholder={PermCountryValuePopulate?PermCountryValuePopulate:permanentcountry} fontsize="12" fontfamily="'Poppins', sans-serif" options={countryresponse} />
                                            </div>
                                        </div>
                                    </div>
                                    </Col>
                                    <Col lg={4} className='pr5 pl5'>
                                    <div className="basicinputfield h35p">
                                        <p>Division</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={borderpermanentdivision} func={drpfuncprdivision} myplaceholder={permanentdivisionValuePopulate?permanentdivisionValuePopulate:permanentdivision} fontsize="12" fontfamily="'Poppins', sans-serif" options={divisionresponse} />
                                            </div>
                                        </div>
                                    </div>
                                    </Col>
                                    <Col lg={4} className='pl5'>
                                    <div className="basicinputfield h35p">
                                        <p>District</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={borderpermanentdistrict} func={drpfuncprdisctict} myplaceholder={permanentdistrictValuePopulate?permanentdistrictValuePopulate:permanentdistrict} fontsize="12" fontfamily="'Poppins', sans-serif" options={districtresponse} />
                                            </div>
                                        </div>
                                    </div>
                                    </Col>
                                    <Col lg={4} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>Thana</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={borderpermanentthana} func={drpfuncprthana} myplaceholder={permanentthanaValuePopulate?permanentthanaValuePopulate:permanentthana} fontsize="12" fontfamily="'Poppins', sans-serif" options={thanaresponse} />
                                            </div>
                                        </div>
                                    </div>
                                    </Col>
                                    <Col lg={12}>
                                    <div className="checkboxfull d-flex " style={{marginBottom:"25px"}}>

                                        <input
                                        type="checkbox"
                                        value={isSameaddress}
                                        onChange={handleSameaddress}
                                        id="remember"
                                        name="subscribe"
                                        />
                                        <span style={{fontSize:"12px",transform:"translateY(2px)"}}>Same As Present Adress</span>


                                        </div>
                                    </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    </Row>

                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                           

                            <div className="stumainentrybox2">
                            <Row>
                                        <Col lg={3} className="pr7">
                                        <div className="billbox paymentcollectbox stuCommonformbox " >
                                            <div className="titlewithwhite">
                                                <p>Father's Info</p>
                                            </div>

                                            <Row>
                                            <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>First</p>
                                                <div className="inputgap h35">
                                                    <input style={borderffirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={ffirstname} onChange={(e) => setffirstname(e.target.value)} />
                                                    <label>{labelffirstname}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>Middle</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fmiddlename} onChange={(e) => setfmiddlename(e.target.value)} />
                                                    <label>{labelfmiddlename}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={12} >
                                            <div className="basicinputfield h35p">
                                                <p>Last</p>
                                                <div className="inputgap h35">
                                                    <input style={borderflastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={flastname} onChange={(e) => setflastname(e.target.value)} />
                                                    <label>{labelflastname}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>Mobile</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfmobile ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fmobile} onChange={(e) => setfmobile(e.target.value)} />
                                                    <label>{labelfmobile}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={12} >
                                            <div className="basicinputfield h35p">
                                                <p>National ID</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfnationalid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fnationalid} onChange={(e) => setfnationalid(e.target.value)} />
                                                    <label>{labelfnationalid}</label>
                                                </div>
                                            </div>
                                        </Col>
                                      
                                            </Row>
                                        </div>
                                        </Col>
                                        <Col lg={3} className="pr7">
    <div className="billbox paymentcollectbox stuCommonformbox " >
        <div className="titlewithwhite">
            <p>Mother's Info</p>
        </div>

        <Row>
        <Col lg={12}>
        <div className="basicinputfield h35p">
            <p>First</p>
            <div className="inputgap h35">
                <input style={bordermfirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mfirstname} onChange={(e) => setmfirstname(e.target.value)} />
                <label>{labelmfirstname}</label>
            </div>
        </div>
    </Col>
        <Col lg={12}>
        <div className="basicinputfield h35p">
            <p>Middle</p>
            <div className="inputgap h35">
                <input style={bordermmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mmiddlename} onChange={(e) => setmmiddlename(e.target.value)} />
                <label>{labelmmiddlename}</label>
            </div>
        </div>
    </Col>
        <Col lg={12} >
        <div className="basicinputfield h35p">
            <p>Last</p>
            <div className="inputgap h35">
                <input style={bordermlastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mlastname} onChange={(e) => setmlastname(e.target.value)} />
                <label>{labelmlastname}</label>
            </div>
        </div>
    </Col>
    <Col lg={12}>
        <div className="basicinputfield h35p">
            <p>Mobile</p>
            <div className="inputgap h35">
                <input style={bordermmobile ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mmobile} onChange={(e) => setmmobile(e.target.value)} />
                <label>{labelmmobile}</label>
            </div>
        </div>
    </Col>
    <Col lg={12} >
        <div className="basicinputfield h35p">
            <p>National ID</p>
            <div className="inputgap h35">
                <input style={bordermnationalid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mnationalid} onChange={(e) => setmnationalid(e.target.value)} />
                <label>{labelmnationalid}</label>
            </div>
        </div>
    </Col>
  
        </Row>
    </div>
    </Col>
                        <Col lg={3} className="pl5 pr5">
                            <div className="billbox paymentcollectbox stuCommonformbox " >
                                <div className="titlewithwhite">
                                    <p>Spouse's Info</p>
                                </div>
                                <Row>
                                    <Col lg={12}>
                                        <div className="basicinputfield h35p">
                                            <p>First</p>
                                            <div className="inputgap h35">
                                                <input style={borderspfirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={spfirstname} onChange={(e) => setspfirstname(e.target.value)} />
                                                <label>{labelspfirstname}</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={12}>
                                        <div className="basicinputfield h35p">
                                            <p>Middle</p>
                                            <div className="inputgap h35">
                                                <input style={borderspmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={spmiddlename} onChange={(e) => setspmiddlename(e.target.value)} />
                                                <label>{labelspmiddlename}</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={12} >
                                        <div className="basicinputfield h35p">
                                            <p>Last</p>
                                            <div className="inputgap h35">
                                                <input style={bordersplastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={splastname} onChange={(e) => setsplastname(e.target.value)} />
                                                <label>{labelsplastname}</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={12}>
                                        <div className="basicinputfield h35p">
                                            <p>Mobile</p>
                                            <div className="inputgap h35">
                                                <input style={borderspmobile ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={spmobile} onChange={(e) => setspmobile(e.target.value)} />
                                                <label>{labelspmobile}</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={12} >
                                        <div className="basicinputfield h35p">
                                            <p>National ID</p>
                                            <div className="inputgap h35">
                                                <input style={borderspnationalid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={spnationalid} onChange={(e) => setspnationalid(e.target.value)} />
                                                <label>{labelspnationalid}</label>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col lg={3} className="pl5">
                            <div className="billbox paymentcollectbox stuCommonformbox">
                                <div className="titlewithwhite">
                                    <p>Marital Info</p>
                                </div>

                                <Row>
                                <Col lg={12}>
                                <div className="basicinputfield h35p">
                                    <p>Marital Status</p>
                                    <div className="inputgap h35">
                                        <div className="dropdownwrapper">
                                            <Dropdown2 err={bordermaritalstatus} func={drpfunctionmaritalstatus} myplaceholder={MaritalStatusValuePopulate}fontsize="12" fontfamily="'Poppins', sans-serif" options={maritalstatusresponse} />
                                        </div>
                                        <label>{labelmaritalstatus}</label>
                                        
                                    </div>
                                </div>
                                    </Col>
                                <Col lg={12}>
                                        <div className="basicinputfield h35p">
                                            <p>No of Dependant</p>
                                            <div className="inputgap h35">
                                                <input style={bordernoofdependant ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="number" value={noofdependant} onChange={(e) => setnoofdependant(e.target.value)} />
                                                <label>{labelnoofdependant}</label>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                            </div>
                        </Col>
                    </Row>
                </div>
                          
                        </Tab.Pane>
                        <Tab.Pane eventKey="third" className='px75'>
                            <div className="stumainentrybox2">
                            <Row>
                                        <Col lg={3} className="pr5">
                                        
                                        <div className="billbox px-0">

                                            <Row>
                                            <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>Passport</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpassportemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={passportemp} onChange={(e) => setpassportemp(e.target.value)} />
                                                    <label>{labelpassportemp}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>National ID</p>
                                                <div className="inputgap h35">
                                                    <input style={bordernationalidemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={nationalidemp} onChange={(e) => setnationalidemp(e.target.value)} />
                                                    <label>{labelnationalidemp}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>Driving License No</p>
                                                <div className="inputgap h35">
                                                    <input style={borderdrivinglicensenoemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={drivinglicensenoemp} onChange={(e) => setdrivinglicensenoemp(e.target.value)} />
                                                    <label>{labeldrivinglicensenoemp}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>Signature</p>
                                                <div className="inputgap h35">
                                                    <input style={bordersignatureemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={signatureemp} onChange={(e) => setsignatureemp(e.target.value)} />
                                                    <label>{labelsignatureemp}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        </Row>
                                        </div>
                                      
                                        </Col>
                                        <Col lg={3} className="pr5 pl5">
                                            <div className="billbox px-0">
                                                <Row>
                                                    <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                                                    <p>Blood Group</p>
                                                    <div className="inputgap h35">
                                                        <div className="dropdownwrapper">
                                                            <Dropdown2 err={borderbloodgroupemp} func={drpfunctionbloodgroupemp} myplaceholder={bloodgroupValuePopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={bloodgroupresponse} />
                                                        </div>
                                                        <label>{labelbloodgroupemp}</label>
                                                        
                                                    </div>
                                                </div>
                                                    </Col>
                                                    <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                                                    <p>Naitonality</p>
                                                    <div className="inputgap h35">
                                                        <div className="dropdownwrapper">
                                                            <Dropdown2 err={bordernationalityemp} func={drpfunctionnationalityemp} myplaceholder={nationalityValuePopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={nationalityresponse} />
                                                        </div>
                                                        <label>{labelnationalityemp}</label>
                                                        
                                                    </div>
                                                </div>
                                                    </Col>
                                                    <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                                                    <p>Religion</p>
                                                    <div className="inputgap h35">
                                                        <div className="dropdownwrapper">
                                                            <Dropdown2 err={borderreligionemp} func={drpfunctionreligionemp} myplaceholder={religionValuePopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={religionresponse} />
                                                        </div>
                                                        <label>{labelreligionemp}</label>
                                                        
                                                    </div>
                                                </div>
                                                    </Col>
                                                    <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                        <p>Death Date</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <div className="inputgap h35">

                                <DatePicker

                                    value={deathdateemp}
                                    onChange={(newvaldob) => handledeathdateemp(newvaldob)}
                                    renderInput={(params) => 
                                    <TextField style={borderdeathdateemp==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                        ...params.inputProps,
                                        placeholder: ""
                                    }} error={false} />}
                                />
                                <label>{labeldeathdateemp}</label>
                                
                                
                            </div>
                        </LocalizationProvider>
                    </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col lg={3} className='pr5 pl5'>
                                            <div className="billbox px-0">
                                                <Row>
                                                <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                                                    <p>Birth Country</p>
                                                    <div className="inputgap h35">
                                                        <div className="dropdownwrapper">
                                                            <Dropdown2 err={borderbirthcountryemp} func={drpfunctionbirthcountryemp} myplaceholder={BirthCountryValuePopulate}fontsize="12" fontfamily="'Poppins', sans-serif" options={countryresponse} />
                                                        </div>
                                                        <label>{labelbirthcountryemp}</label>
                                                        
                                                    </div>
                                                </div>
                                                    </Col>
                                                <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                                                    <p>Birth Division</p>
                                                    <div className="inputgap h35">
                                                        <div className="dropdownwrapper">
                                                            <Dropdown2 err={borderbirthdivisionemp} func={drpfunctionbirthdivisionemp} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={divisionresponse} />
                                                        </div>
                                                        <label>{labelbirthdivisionemp}</label>
                                                        
                                                    </div>
                                                </div>
                                                    </Col>
                                                <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                                                    <p>Birth City</p>
                                                    <div className="inputgap h35">
                                                        <div className="dropdownwrapper">
                                                            <Dropdown2 err={borderbirthcityemp} func={drpfunctionbirthcityemp} myplaceholder={BirthCityValuePopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={districtresponse} />
                                                        </div>
                                                        <label>{labelbirthcityemp}</label>
                                                        
                                                    </div>
                                                </div>
                                                    </Col>
                                                <Col lg={12}>
                                                <div className="basicinputfield h35p">
                                                    <p>Birth Place</p>
                                                        <div className="inputgap h35">
                                                            <input style={borderbirthplaceemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={birthplaceemp} onChange={(e) => setbirthplaceemp(e.target.value)} />
                                                            <label>{labelbirthplaceemp}</label>
                                                        </div>
                                                    </div>
                                           
                                                    </Col>
                                                  
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col lg={3} className="pl5">
                                            <div className="billbox px-0">
                                                <Row>
                                                <Col lg={12}>
                                                    <div className="basicinputfield h35p">
                                                    <p>User Name</p>
                                                        <div className="inputgap h35">
                                                            <input style={borderusernameemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={usernameemp} onChange={(e) => setusernameemp(e.target.value)} />
                                                            <label>{labelusernameemp}</label>
                                                        </div>
                                                    </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        </Row>
                                        </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="fourth" className='w560 m-auto'>
                                        <div className="stumainentrybox2">
                                            <div className="billbox px-0">
                                            <Row>
                                                <Col lg={6} className="pr5">
                                                <div className="basicinputfield h35p">
                                                    <p>Referrer Name</p>
                                                    <div className="inputgap h35">
                                                        <input style={borderreferrernameemp ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={referrernameemp} onChange={(e) => setreferrernameemp(e.target.value)} />
                                                        <label>{labelreferrernameemp}</label>
                                                    </div>
                                                </div>

                                                </Col>
                                                <Col lg={6} className="pl5">
                                                <div className="basicinputfield h35p">
                                                    <p>Organization</p>
                                                    <div className="inputgap h35">
                                                        <input style={borderorganizationref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={organizationref} onChange={(e) => setorganizationref(e.target.value)} />
                                                        <label>{labelorganizationref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={6} className="pr5">
                                                <div className="basicinputfield h35p">
                                                    <p>Designation</p>
                                                    <div className="inputgap h35">
                                                        <input style={borderdesignationref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={designationref} onChange={(e) => setdesignationref(e.target.value)} />
                                                        <label>{labeldesignationref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={6} className="pl5">
                                                <div className="basicinputfield h35p">
                                                    <p>Relation</p>
                                                    <div className="inputgap h35">
                                                        <input style={borderrelationref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={relationref} onChange={(e) => setrelationref(e.target.value)} />
                                                        <label>{labelrelationref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={12}>
                                                <div className="basicinputfield h35p">
                                                    <p>Address 1</p>
                                                    <div className="inputgap h35">
                                                        <input style={borderaddress1ref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={address1ref} onChange={(e) => setaddress1ref(e.target.value)} />
                                                        <label>{labeladdress1ref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={6} className="pr5">
                                                <div className="basicinputfield h35p">
                                                    <p>Mobile 1</p>
                                                    <div className="inputgap h35">
                                                        <input style={bordermobile1ref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mobile1ref} onChange={(e) => setmobile1ref(e.target.value)} />
                                                        <label>{labelmobile1ref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={6} className="pl5">
                                                <div className="basicinputfield h35p">
                                                    <p>Mobile 2</p>
                                                    <div className="inputgap h35">
                                                        <input style={bordermobile2ref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mobile2ref} onChange={(e) => setmobile2ref(e.target.value)} />
                                                        <label>{labelmobile2ref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={6} className="pr5">
                                                <div className="basicinputfield h35p">
                                                    <p>Email</p>
                                                    <div className="inputgap h35">
                                                        <input style={borderemailref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={emailref} onChange={(e) => setemailref(e.target.value)} />
                                                        <label>{labelemailref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={6} className="pl5">
                                                <div className="basicinputfield h35p">
                                                    <p>Reffer Id</p>
                                                    <div className="inputgap h35">
                                                        <input disabled style={borderrefferIdref ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={refferIdref} onChange={(e) => setrefferIdref(e.target.value)} />
                                                        <label>{labelrefferIdref}</label>
                                                    </div>
                                                </div>
                                                </Col>
                                                <Col lg={12}>
                                                    <Purplebutton clickfunc={handleRefSaveButtonClick} btnname="Add New" w="117px" h="40px" mt="20px"/>

                                                </Col>
                                            </Row>

                                            </div>
                                        </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="fifth" className='w780 m-auto'>
                                            <div className="stumainentrybox2">
                                                <Row>
                                                   <Col lg={12}>
                                                    <div className="flexvaluetable empentrytable">

                                                    <table>
                                                        <thead>
                                                            <tr>
                                                            {
                                                                employeeEntryqualificationApi.heading.map((item,key)=>{
                                                                    return(
                                                                            <th key={key}>{item.head}</th>
                                                                            
                                                                            )
                                                                        })
                                                            }
                                                                        </tr>
                                                            
                                                            
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                EmpQualificationResponse? EmpQualificationResponse.map((item,key)=>{
                                                                    return(
                                                                        <tr style={{cursor:"pointer"}} onClick={()=>handleQauliRowClick(item)}>
                                                                            <td>{item.qualiName}</td>
                                                                            <td>{item.subject}</td>
                                                                            <td>{item.institute}</td>
                                                                            <td>{item.board}</td>
                                                                            <td>{item.passYear}</td>
                                                                            <td>{item.result}</td>
                                                                        </tr>
                                                                    )
                                                                }) : ""
                                                            }
                                                           
                                                            
                                                        </tbody>
                                                    </table>
                                                    </div>
                                                   </Col>
                                                   <Col lg={12}>
                                                    <Row style={{marginTop:"20px"}}>
                                                        <Col lg={4} className="pr5">
                                                        <div className="basicinput">
                                                            <p>Qualificaiton</p>
                                                            <div className="inputgap h35p">
                                                                <div className="dropdownwrapper h35">
                                                                    <Dropdown2 err={borderqualificationAdd === "err" ? "err" : ""} func={drpfuncqualificationAdd} myplaceholder={QulificationNamePopulate} fontsize="12px" fontfamily="'Poppins', sans-serif" options={QulificationResponse} />
                                                                </div>
                                                                <label>{labelqualificationAdd}</label>
                                                            </div>
                                                        </div>
                                                        </Col>
                                                        <Col lg={4} className="pr5 pl5">
                                                        <div className="basicinput">
                                                            <p>Subject</p>
                                                            <div className="inputgap h35p">
                                                                <div className="dropdownwrapper h35">
                                                                    <Dropdown2 err={bordersubjectAdd === "err" ? "err" : ""} func={drpfuncsubjectAdd} myplaceholder={QualificationSubject} fontsize="12px" fontfamily="'Poppins', sans-serif" options={SubjectResponse} />
                                                                </div>
                                                                <label>{labelsubjectAdd}</label>
                                                            </div>
                                                        </div>
                                                        </Col>
                                                        <Col lg={4} className="pr5 pl5">
                                                        <div className="basicinput">
                                                            <p>Institute</p>
                                                            <div className="inputgap h35p">
                                                                <div className="dropdownwrapper h35">
                                                                    <Dropdown2 err={borderinstituteAdd === "err" ? "err" : ""} func={drpfuncinstituteAdd} myplaceholder={QualificationInstitute} fontsize="12px" fontfamily="'Poppins', sans-serif" options={InstituteResponse} />
                                                                </div>
                                                                <label>{labelinstituteAdd}</label>
                                                            </div>
                                                        </div>
                                                        </Col>
                                                        <Col lg={3} className="pr5">
                                                        <div className="basicinput">
                                                            <p>Board</p>
                                                            <div className="inputgap h35p">
                                                                <div className="dropdownwrapper h35">
                                                                    <Dropdown2 err={borderboardAdd === "err" ? "err" : ""} func={drpfuncboardAdd} myplaceholder={QualificationBoard} fontsize="12px" fontfamily="'Poppins', sans-serif" options={BoardResponse} />
                                                                </div>
                                                                <label>{labelboardAdd}</label>
                                                            </div>
                                                        </div>
                                                        </Col>
                                                        <Col lg={3} className="pr5">
                                                            <div className="basicinput">
                                                                <p>Result</p>
                                                                <div className="inputgap h35p">
                                                                    <input type="text" style={borderresultAdd ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={resultAdd} onChange={(e)=>setresultAdd(e.target.value)} />
                                                                    <label>{labelresultAdd}</label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col lg={3}  className="pr5 pl5">
                                                            <div className="basicinput">
                                                                <p>Pass Year</p>
                                                                <div className="inputgap h35p">
                                                                    <input type="text" style={borderpassyearAdd ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={passyearAdd} onChange={(e)=>setpassyearAdd(e.target.value)} />
                                                                    <label>{labelpassyearAdd}</label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col lg={3} className="pl5 text-center">
                                                        <div className="basicinput w-100">
                                                                <p></p>
                                                                <Purplebutton clickfunc={handleAddQuali} w="100%" h="35px" btnname="Save" mt="0px" >
                                                                </Purplebutton>
                                                                </div>
                                                        </Col>
                                                    </Row>
                                                   </Col>
                                                </Row>
                                            </div>

                                        </Tab.Pane>
                                        <Tab.Pane eventKey="sixth" className='w780 m-auto'>
                                            <div className="stumainentrybox2">
                                                <Row>
                                                   <Col lg={12}>
                                                    <div className="flexvaluetable empentrytable">

                                                    <table>
                                                        <thead>
                                                            <tr>
                                                            {
                                                                employeeEntryexperienceApi.heading.map((item,key)=>{
                                                                    return(
                                                                            <th key={key}>{item.head}</th>
                                                                            
                                                                            )
                                                                        })
                                                            }
                                                                        </tr>
                                                            
                                                            
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                EmpExpresponse ? EmpExpresponse.map((item,key)=>{
                                                                    return(
                                                                        <tr style={{cursor:"pointer"}} onClick={()=>handleExpRowClick(item)}>
                                                                            <td>{item.companyName}</td>
                                                                            <td>{item.location}</td>
                                                                            <td>{item.position}</td>
                                                                            <td>{item.responsibility}</td>
                                                                            <td>{item.startDate}</td>
                                                                            <td>{item.endDate}</td>
                                                                        </tr>
                                                                    )
                                                                }) : ""
                                                            }
                                                           
                                                            
                                                        </tbody>
                                                    </table>
                                                    </div>
                                                   </Col>
                                                   <Col lg={12} style={{marginTop:"25px"}}>
                                                    <Row>
                                                    <Col lg={3} className='pr5'>
                                                        <div className="basicinputfield h35p">
                                                            <p>Company</p>
                                                            <div className="inputgap h35">
                                                                <div className="dropdownwrapper">
                                                                    <Dropdown2 err={borderexpCompany} func={drpfuncexpcompany} myplaceholder={ExpCompanyValue}fontsize="12px" fontfamily="'Poppins', sans-serif" options={ExpCompanyResponse} />
                                                                </div>
                                                                <label>{labelexpCompany}</label>
                                                                
                                                            </div>
                                                        </div>
                                                        </Col>
                                                    <Col lg={3} className='pr5'>
                                                        <div className="basicinputfield h35p">
                                                            <p>Position</p>
                                                            <div className="inputgap h35">
                                                                <div className="dropdownwrapper">
                                                                    <Dropdown2 err={borderexpPosition} func={drpfuncexpposition} myplaceholder={ExpPositionValue}fontsize="12px" fontfamily="'Poppins', sans-serif" options={PositionResponse} />
                                                                </div>
                                                                <label>{labelexpPosition}</label>
                                                                
                                                            </div>
                                                        </div>
                                                        </Col>
                                                        <Col lg={3}  className="pr5 pl5">
                                                            <div className="basicinput">
                                                                <p>Location</p>
                                                                <div className="inputgap h35p">
                                                                    <input type="text" style={borderexpLocation ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={expLocation} onChange={(e)=>setexpLocation(e.target.value)} />
                                                                    <label>{labelexpLocation}</label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col lg={3}  className="pr5 pl5">
                                                            <div className="basicinput">
                                                                <p>Responsibility</p>
                                                                <div className="inputgap h35p">
                                                                    <input type="text" style={borderexpResponsibility ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={expResponsibility} onChange={(e)=>setexpResponsibility(e.target.value)} />
                                                                    <label>{labelexpResponsibility}</label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col lg={10} className='m-auto'>
                                                            <Row>
                                                            <Col lg={4}>
                                                    <div className="basicinputfield h35p">
                                                        <p>Start Date</p>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <div className="inputgap h35">

                                                                <DatePicker

                                                                    value={expStartDate}
                                                                    onChange={(newvaldob) => handleexpStartDate(newvaldob)}
                                                                    renderInput={(params) => 
                                                                    <TextField style={borderexpStartDate==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                                        ...params.inputProps,
                                                                        placeholder: ""
                                                                    }} error={false} />}
                                                                />
                                                                <label>{labelexpStartDate}</label>
                                                                
                                                                
                                                            </div>
                                                        </LocalizationProvider>
                                                    </div>
                                                    </Col>
                                                        <Col lg={4}>
                                                    <div className="basicinputfield h35p">
                                                        <p>End Date</p>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <div className="inputgap h35">

                                                                <DatePicker

                                                                    value={expEndDate}
                                                                    onChange={(newvaldob) => handleexpEndDate(newvaldob)}
                                                                    renderInput={(params) => 
                                                                    <TextField style={borderexpEndDate==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                                        ...params.inputProps,
                                                                        placeholder: ""
                                                                    }} error={false} />}
                                                                />
                                                                <label>{labelexpEndDate}</label>
                                                                
                                                                
                                                            </div>
                                                        </LocalizationProvider>
                                                    </div>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Purplebutton mt="20px" clickfunc={handleAddEmpExp} btnname="Add" w="100%" h="35px" />
                                                    </Col> 
                                                            </Row>
                                                        </Col>
                                                                                                           
                                                    </Row>
                                                   </Col>
                                                </Row>

                                            </div>

                                        </Tab.Pane>
                           
                        </Tab.Content>
                        
                    </Col>
                    </Row>
                    </Tab.Container>
                    </div>
                    </div>
                </div>
    </div>
    </div>
    </div>
  )
}

export default EmpEntryMainComp